var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
import Language from "./language";
export var Translation;
(function (Translation) {
    Translation[Translation["AgentIsTyping"] = 0] = "AgentIsTyping";
    Translation[Translation["Back"] = 1] = "Back";
    Translation[Translation["BlockedAttachmentMessage"] = 2] = "BlockedAttachmentMessage";
    Translation[Translation["BlockedAttachmentTitle"] = 3] = "BlockedAttachmentTitle";
    Translation[Translation["Cancel"] = 4] = "Cancel";
    Translation[Translation["ChangeLanguage"] = 5] = "ChangeLanguage";
    Translation[Translation["ChatEnded"] = 6] = "ChatEnded";
    Translation[Translation["ChatInputPlaceholder"] = 7] = "ChatInputPlaceholder";
    Translation[Translation["CloseWindow"] = 8] = "CloseWindow";
    Translation[Translation["DownloadTranscriptButton"] = 9] = "DownloadTranscriptButton";
    Translation[Translation["EmailTranscript"] = 10] = "EmailTranscript";
    Translation[Translation["EndChatButton"] = 11] = "EndChatButton";
    Translation[Translation["EndChatModalMessage"] = 12] = "EndChatModalMessage";
    Translation[Translation["EndChatModalTitle"] = 13] = "EndChatModalTitle";
    Translation[Translation["EmptySelect"] = 14] = "EmptySelect";
    Translation[Translation["Error"] = 15] = "Error";
    Translation[Translation["ErrorInvalid"] = 16] = "ErrorInvalid";
    Translation[Translation["ErrorRequired"] = 17] = "ErrorRequired";
    Translation[Translation["FinishedChatMoreOptions"] = 18] = "FinishedChatMoreOptions";
    Translation[Translation["FormError"] = 19] = "FormError";
    Translation[Translation["GoToSurvey"] = 20] = "GoToSurvey";
    Translation[Translation["MinimiseWindow"] = 21] = "MinimiseWindow";
    Translation[Translation["Mute"] = 22] = "Mute";
    Translation[Translation["NoItemsFound"] = 23] = "NoItemsFound";
    Translation[Translation["NewChat"] = 24] = "NewChat";
    Translation[Translation["OpenChat"] = 25] = "OpenChat";
    Translation[Translation["PrintTranscriptButton"] = 26] = "PrintTranscriptButton";
    Translation[Translation["RequestTranscriptButton"] = 27] = "RequestTranscriptButton";
    Translation[Translation["RequestTranscriptEmailLabel"] = 28] = "RequestTranscriptEmailLabel";
    Translation[Translation["RequestTranscriptModalTitle"] = 29] = "RequestTranscriptModalTitle";
    Translation[Translation["SkipSurvey"] = 30] = "SkipSurvey";
    Translation[Translation["StartChat"] = 31] = "StartChat";
    Translation[Translation["Submit"] = 32] = "Submit";
    Translation[Translation["SurveyThanks"] = 33] = "SurveyThanks";
    Translation[Translation["Title"] = 34] = "Title";
    Translation[Translation["TooEarly"] = 35] = "TooEarly";
    Translation[Translation["TooLate"] = 36] = "TooLate";
    Translation[Translation["TranscriptRequested"] = 37] = "TranscriptRequested";
    Translation[Translation["TryingReconnect"] = 38] = "TryingReconnect";
    Translation[Translation["TypeToSearch"] = 39] = "TypeToSearch";
    Translation[Translation["Typing"] = 40] = "Typing";
    Translation[Translation["Unmute"] = 41] = "Unmute";
    Translation[Translation["ViewChat"] = 42] = "ViewChat";
    Translation[Translation["Yes"] = 43] = "Yes";
})(Translation || (Translation = {}));
/* tslint:disable:max-line-length */
export var locales = (_a = {},
    _a[Language.English] = (_b = {},
        _b[Translation.ChatEnded] = "The chat has ended.",
        _b[Translation.ChangeLanguage] = "Change Language",
        _b[Translation.SurveyThanks] = "Thanks for your feedback.",
        _b[Translation.Unmute] = "Unmute notification sounds",
        _b[Translation.OpenChat] = "Open Chat Support",
        _b[Translation.Error] = "Error",
        _b[Translation.BlockedAttachmentMessage] = "Please enable pop-ups in your browser to view this attachment.",
        _b[Translation.RequestTranscriptButton] = "Email Transcript",
        _b[Translation.Cancel] = "Cancel",
        _b[Translation.Submit] = "Submit",
        _b[Translation.RequestTranscriptModalTitle] = "Request Transcript",
        _b[Translation.FormError] = "Please fix the errors on the form to continue.",
        _b[Translation.EndChatModalMessage] = "Are you sure you want to end the chat?",
        _b[Translation.ViewChat] = "View Transcript",
        _b[Translation.Typing] = "typing",
        _b[Translation.ErrorInvalid] = "Invalid",
        _b[Translation.TranscriptRequested] = "Transcript Requested",
        _b[Translation.RequestTranscriptEmailLabel] = "Your email address",
        _b[Translation.Yes] = "Yes",
        _b[Translation.BlockedAttachmentTitle] = "Attachments Blocked",
        _b[Translation.AgentIsTyping] = "The agent is typing...",
        _b[Translation.EndChatButton] = "End Chat",
        _b[Translation.SkipSurvey] = "Skip Feedback",
        _b[Translation.ErrorRequired] = "Required",
        _b[Translation.NewChat] = "New Chat",
        _b[Translation.GoToSurvey] = "Rate Your Experience",
        _b[Translation.ChatInputPlaceholder] = "Your message...",
        _b[Translation.Mute] = "Mute notification sounds",
        _b[Translation.FinishedChatMoreOptions] = "More Options",
        _b[Translation.EmailTranscript] = "Email Transcript",
        _b[Translation.PrintTranscriptButton] = "Print Transcript",
        _b[Translation.CloseWindow] = "Close chat window",
        _b[Translation.Title] = "Help",
        _b[Translation.TooEarly] = "Too early",
        _b[Translation.TooLate] = "Too late",
        _b[Translation.TryingReconnect] = "Trying to reconnect",
        _b[Translation.Back] = "Back",
        _b[Translation.StartChat] = "Start Chat",
        _b[Translation.EndChatModalTitle] = "End Chat",
        _b[Translation.MinimiseWindow] = "Minimise Chat Window",
        _b[Translation.PrintTranscriptButton] = "Print Transcript",
        _b[Translation.DownloadTranscriptButton] = "Download Transcript",
        _b[Translation.EmptySelect] = "Nothing selected",
        _b[Translation.NoItemsFound] = "No results found",
        _b[Translation.TypeToSearch] = "Search...",
        _b),
    _a[Language.Estonian] = (_c = {},
        _c[Translation.ChatEnded] = "Vestlus on lõppenud",
        _c[Translation.ChangeLanguage] = "Muuda keelt",
        _c[Translation.SurveyThanks] = "Täname tagasiside eest.",
        _c[Translation.Unmute] = "Tühista teavitushelide vaigistus",
        _c[Translation.OpenChat] = "Avage vestluse tugi",
        _c[Translation.Error] = "Viga",
        _c[Translation.BlockedAttachmentMessage] = "Selle manuse vaatamiseks lubage oma brauseris hüpikaknad.",
        _c[Translation.RequestTranscriptButton] = "Meili ärakiri",
        _c[Translation.Cancel] = "Tühista",
        _c[Translation.Submit] = "Esita",
        _c[Translation.RequestTranscriptModalTitle] = "Taotle ärakirja",
        _c[Translation.FormError] = "Jätkamiseks parandage vormil olevad vead.",
        _c[Translation.EndChatModalMessage] = "Kas olete kindel, et soovite vestluse lõpetada?",
        _c[Translation.ViewChat] = "Vaata ärakirja",
        _c[Translation.Typing] = "trükkimine",
        _c[Translation.ErrorInvalid] = "Kehtetu",
        _c[Translation.TranscriptRequested] = "Taotletud ärakirja",
        _c[Translation.RequestTranscriptEmailLabel] = "Sinu emaili aadress",
        _c[Translation.Yes] = "Jah",
        _c[Translation.BlockedAttachmentTitle] = "Manused blokeeritud",
        _c[Translation.AgentIsTyping] = "Agent kirjutab...",
        _c[Translation.EndChatButton] = "Lõpeta vestlus",
        _c[Translation.SkipSurvey] = "Jäta tagasiside vahele",
        _c[Translation.ErrorRequired] = "Nõutud",
        _c[Translation.NewChat] = "Uus vestlus",
        _c[Translation.GoToSurvey] = "Hinnake oma kogemusi",
        _c[Translation.ChatInputPlaceholder] = "Sinu sõnum...",
        _c[Translation.Mute] = "Vaigista teavitushelid",
        _c[Translation.FinishedChatMoreOptions] = "Veel valikuid",
        _c[Translation.EmailTranscript] = "Meili ärakiri",
        _c[Translation.PrintTranscriptButton] = "Prindi ärakiri",
        _c[Translation.CloseWindow] = "Sulgege vestlusaken",
        _c[Translation.Title] = "Abi",
        _c[Translation.TooEarly] = "Liiga vara",
        _c[Translation.TooLate] = "Liiga hilja",
        _c[Translation.TryingReconnect] = "Proovin uuesti ühendust luua",
        _c[Translation.Back] = "Tagasi",
        _c[Translation.StartChat] = "Alusta vestlust",
        _c[Translation.EndChatModalTitle] = "Lõpeta vestlus",
        _c[Translation.MinimiseWindow] = "Minimeeri vestlusaken",
        _c[Translation.PrintTranscriptButton] = "Prindi ärakiri",
        _c[Translation.DownloadTranscriptButton] = "Laadige alla transkriptsioon",
        _c[Translation.EmptySelect] = "Midagi pole valitud",
        _c[Translation.NoItemsFound] = "Tulemusi ei leitud",
        _c[Translation.TypeToSearch] = "Otsing...",
        _c),
    _a[Language.German] = (_d = {},
        _d[Translation.ChatEnded] = "Der Chat wurde beendet.",
        _d[Translation.ChangeLanguage] = "Sprache ändern",
        _d[Translation.SurveyThanks] = "Vielen Dank für Ihr Feedback.",
        _d[Translation.Unmute] = "Stummschaltung der Benachrichtigungen aufheben",
        _d[Translation.OpenChat] = "Chat Support öffnen",
        _d[Translation.Error] = "Fehler",
        _d[Translation.BlockedAttachmentMessage] = "Bitte aktivieren Sie Pop-ups in Ihrem Browser, um diesen Anhang anzuzeigen.",
        _d[Translation.RequestTranscriptButton] = "Email Transkript",
        _d[Translation.Cancel] = "Nein",
        _d[Translation.Submit] = "Einreichen",
        _d[Translation.RequestTranscriptModalTitle] = "Transkript anfordern",
        _d[Translation.FormError] = "Bitte korrigieren Sie die Fehler im Formular um fortzufahren.",
        _d[Translation.EndChatModalMessage] = "Sind Sie sicher, dass Sie den Chat beenden möchten?",
        _d[Translation.ViewChat] = "Transkript anzeigen",
        _d[Translation.Typing] = "Schreibt",
        _d[Translation.ErrorInvalid] = "Ungültig",
        _d[Translation.TranscriptRequested] = "Transkript angefordert",
        _d[Translation.RequestTranscriptEmailLabel] = "Deine Emailadresse",
        _d[Translation.Yes] = "Ja",
        _d[Translation.BlockedAttachmentTitle] = "Anhänge blockiert",
        _d[Translation.AgentIsTyping] = "Der Mitarbeiter schreibt...",
        _d[Translation.EndChatButton] = "Chat beenden",
        _d[Translation.SkipSurvey] = "Umfrage überspringen",
        _d[Translation.ErrorRequired] = "Erforderlich",
        _d[Translation.NewChat] = "Neuer Chat",
        _d[Translation.GoToSurvey] = "Bewerten Sie Ihre Erfahrung",
        _d[Translation.ChatInputPlaceholder] = "Ihre Nachricht",
        _d[Translation.Mute] = "Benachrichtigungen stummschalten",
        _d[Translation.FinishedChatMoreOptions] = "Weitere Optionen",
        _d[Translation.EmailTranscript] = "E-Mail Kopie des Chats",
        _d[Translation.CloseWindow] = "Close chat window",
        _d[Translation.Title] = "Hilfe",
        _d[Translation.TooEarly] = "Ungültig",
        _d[Translation.TooLate] = "Ungültig",
        _d[Translation.TryingReconnect] = "Verbindung wird wiederhergestellt",
        _d[Translation.Back] = "Zurück",
        _d[Translation.StartChat] = "Chat starten",
        _d[Translation.EndChatModalTitle] = "Chat beenden",
        _d[Translation.MinimiseWindow] = "Chat Fenster minimieren",
        _d[Translation.PrintTranscriptButton] = "Protokoll ausdrucken",
        _d[Translation.DownloadTranscriptButton] = "Protokoll herunterladen",
        _d[Translation.EmptySelect] = "Keine Auswahl getätigt",
        _d[Translation.NoItemsFound] = "Keine Ergebnisse gefunden",
        _d[Translation.TypeToSearch] = "Suchen...",
        _d),
    _a[Language.Spanish] = (_e = {},
        _e[Translation.ChatEnded] = "El chat ha finalizado.",
        _e[Translation.ChangeLanguage] = "Cambiar idioma",
        _e[Translation.SurveyThanks] = "Gracias por su opinión.",
        _e[Translation.Unmute] = "Activar notificaciones",
        _e[Translation.OpenChat] = "Inicar chat de soporte",
        _e[Translation.Error] = "Error",
        _e[Translation.BlockedAttachmentMessage] = "Habilite las ventanas emergentes en su navegador para poder ver este archivo adjunto.",
        _e[Translation.RequestTranscriptButton] = "Enviar Transcripción",
        _e[Translation.Cancel] = "Cancelar",
        _e[Translation.Submit] = "Enviar",
        _e[Translation.RequestTranscriptModalTitle] = "Solicitar Transcripción",
        _e[Translation.FormError] = "Por favor, solucione los errores en el formulario para continuar",
        _e[Translation.EndChatModalMessage] = "¿Está seguro de que quiere finalizar el chat?",
        _e[Translation.ViewChat] = "Ver Transcripción",
        _e[Translation.Typing] = "Escribiendo",
        _e[Translation.ErrorInvalid] = "Inválido",
        _e[Translation.TranscriptRequested] = "Transcripción Solicitada",
        _e[Translation.RequestTranscriptEmailLabel] = "Su dirección de correo electrónico",
        _e[Translation.Yes] = "Sí",
        _e[Translation.BlockedAttachmentTitle] = "Archivos Adjuntos Bloqueados",
        _e[Translation.AgentIsTyping] = "El agente está escribiendo...",
        _e[Translation.EndChatButton] = "Terminar chat",
        _e[Translation.SkipSurvey] = "Ignorar encuesta",
        _e[Translation.ErrorRequired] = "Necesario",
        _e[Translation.NewChat] = "Nuevo Chat",
        _e[Translation.GoToSurvey] = "Valore su experiencia",
        _e[Translation.ChatInputPlaceholder] = "Tu mensaje...",
        _e[Translation.Mute] = "Silenciar notificaciones",
        _e[Translation.FinishedChatMoreOptions] = "Más opciones",
        _e[Translation.EmailTranscript] = "Transcripción del correo electrónico",
        _e[Translation.CloseWindow] = "Close chat window",
        _e[Translation.Title] = "Ayuda",
        _e[Translation.TooEarly] = "Inválido",
        _e[Translation.TooLate] = "Inválido",
        _e[Translation.TryingReconnect] = "Intentando reconectar",
        _e[Translation.Back] = "Atrás",
        _e[Translation.StartChat] = "Comenzar chat",
        _e[Translation.EndChatModalTitle] = "Finalizar Chat",
        _e[Translation.MinimiseWindow] = "Minimizar la venta del chat",
        _e[Translation.PrintTranscriptButton] = "Imprimir transcripción",
        _e[Translation.DownloadTranscriptButton] = "Descargar transcripción",
        _e[Translation.EmptySelect] = "Nada seleccionado",
        _e[Translation.NoItemsFound] = "No se han encontrado resultados",
        _e[Translation.TypeToSearch] = "Búsqueda...",
        _e),
    _a[Language.Italian] = (_f = {},
        _f[Translation.ChatEnded] = "La chat é terminata",
        _f[Translation.ChangeLanguage] = "Cambia lingua",
        _f[Translation.SurveyThanks] = "La ringraziamo per il suo feedback.",
        _f[Translation.Unmute] = "Attiva l'audio delle notifiche",
        _f[Translation.OpenChat] = "Apri chat di supporto",
        _f[Translation.Error] = "Errore",
        _f[Translation.BlockedAttachmentMessage] = "Per favore, abiliti pop-ups nel suo browser per visualizzare questo allegato.",
        _f[Translation.RequestTranscriptButton] = "Inviare Trascrizione",
        _f[Translation.Cancel] = "Cancella",
        _f[Translation.Submit] = "Invia",
        _f[Translation.RequestTranscriptModalTitle] = "Richiedi Trascrizione",
        _f[Translation.FormError] = "Per favore, correggi gli errori sul modulo per continuare",
        _f[Translation.EndChatModalMessage] = "É sicuro di voler terminare questa chat?",
        _f[Translation.ViewChat] = "Vedi trascrizione",
        _f[Translation.Typing] = "Scrivendo",
        _f[Translation.ErrorInvalid] = "Invalido",
        _f[Translation.TranscriptRequested] = "Trascrizione Richiesta",
        _f[Translation.RequestTranscriptEmailLabel] = "Il tuo indirizzo email",
        _f[Translation.Yes] = "Si",
        _f[Translation.BlockedAttachmentTitle] = "Allegati bloccati",
        _f[Translation.AgentIsTyping] = "L'operatore sta scrivendo...",
        _f[Translation.EndChatButton] = "Chiudi chat",
        _f[Translation.SkipSurvey] = "Salta il sondaggio",
        _f[Translation.ErrorRequired] = "Richiesto",
        _f[Translation.NewChat] = "Nuova chat",
        _f[Translation.GoToSurvey] = "Valora la sua esperienza",
        _f[Translation.ChatInputPlaceholder] = "Il tuo messaggio...",
        _f[Translation.Mute] = "Disattiva l'audio delle notifiche",
        _f[Translation.FinishedChatMoreOptions] = "Altre opzioni",
        _f[Translation.EmailTranscript] = "Chat trascritta via email",
        _f[Translation.CloseWindow] = "Close chat window",
        _f[Translation.Title] = "Aiuto",
        _f[Translation.TooEarly] = "Invalido",
        _f[Translation.TooLate] = "Invalido",
        _f[Translation.TryingReconnect] = "Riconnessione in corso",
        _f[Translation.Back] = "Indietro",
        _f[Translation.StartChat] = "Inizia la chat",
        _f[Translation.EndChatModalTitle] = "Termina chat",
        _f[Translation.MinimiseWindow] = "Riduci la chat",
        _f[Translation.PrintTranscriptButton] = "Stampa trascrizione",
        _f[Translation.DownloadTranscriptButton] = "Scarica trascrizione",
        _f[Translation.EmptySelect] = "Niente selezionato",
        _f[Translation.NoItemsFound] = "Nessun risultato trovato",
        _f[Translation.TypeToSearch] = "Cerca...",
        _f),
    _a[Language.French] = (_g = {},
        _g[Translation.ChatEnded] = "Le chat est terminé",
        _g[Translation.ChangeLanguage] = "Changement de langue",
        _g[Translation.SurveyThanks] = "Merci pour vos commentaires.",
        _g[Translation.Unmute] = "Réactiver le son des notifications",
        _g[Translation.OpenChat] = "Ouverture du chat",
        _g[Translation.Error] = "Erreur",
        _g[Translation.BlockedAttachmentMessage] = "Veuillez activer les 'pop-ups' dans votre navigateur pour afficher cette pièce jointe.",
        _g[Translation.RequestTranscriptButton] = "Envoyer Transcription",
        _g[Translation.Cancel] = "Annuler",
        _g[Translation.Submit] = "Soumettre",
        _g[Translation.RequestTranscriptModalTitle] = "Demande de Transcription",
        _g[Translation.FormError] = "S'il vous plaît veuillez corriger l'erreur afin de continuer",
        _g[Translation.EndChatModalMessage] = "Êtes-vous sûr de vouloir mettre fin à ce chat?",
        _g[Translation.ViewChat] = "Voir Transcription",
        _g[Translation.Typing] = "En train d'écrire",
        _g[Translation.ErrorInvalid] = "Erreur/ Pas valide",
        _g[Translation.TranscriptRequested] = "Transcription demandée",
        _g[Translation.RequestTranscriptEmailLabel] = "Votre adresse email",
        _g[Translation.Yes] = "Oui",
        _g[Translation.BlockedAttachmentTitle] = "Pièces jointes bloquées",
        _g[Translation.AgentIsTyping] = "L'agent est en train d'écrire",
        _g[Translation.EndChatButton] = "Terminer le chat",
        _g[Translation.SkipSurvey] = "Passer enquête de satisfaction",
        _g[Translation.ErrorRequired] = "Requis",
        _g[Translation.NewChat] = "Nouveau Chat",
        _g[Translation.GoToSurvey] = "Évaluez votre experience",
        _g[Translation.ChatInputPlaceholder] = "Votre texte...",
        _g[Translation.Mute] = "Désactiver le son des notifications",
        _g[Translation.FinishedChatMoreOptions] = "Plus d'options",
        _g[Translation.EmailTranscript] = "Transcription par email",
        _g[Translation.CloseWindow] = "Close chat window",
        _g[Translation.Title] = "Aidez-moi",
        _g[Translation.TooEarly] = "Erreur/ Pas valide",
        _g[Translation.TooLate] = "Erreur/ Pas valide",
        _g[Translation.TryingReconnect] = "On essaye de vous reconnecter",
        _g[Translation.Back] = "Revenier en arrière",
        _g[Translation.StartChat] = "Commencer le chat",
        _g[Translation.EndChatModalTitle] = "Terminer le chat",
        _g[Translation.MinimiseWindow] = "Réduire le chat",
        _g[Translation.PrintTranscriptButton] = "Enquête",
        _g[Translation.DownloadTranscriptButton] = "Télécharger le script",
        _g[Translation.EmptySelect] = "Rien n'a été sélectionné",
        _g[Translation.NoItemsFound] = "Aucun résultat n'a été trouvé",
        _g[Translation.TypeToSearch] = "Rechercher...",
        _g),
    _a[Language.Dutch] = (_h = {},
        _h[Translation.ChatEnded] = "De chat is beëindigd.",
        _h[Translation.ChangeLanguage] = "Verander taal",
        _h[Translation.SurveyThanks] = "Bedankt voor uw feedback.",
        _h[Translation.Unmute] = "Demping van meldingsgeluiden opheffen",
        _h[Translation.OpenChat] = "Open chat venster",
        _h[Translation.Error] = "Fout",
        _h[Translation.BlockedAttachmentMessage] = "Laat pop-ups toe in uw browser om deze bijlagen te bekijken.",
        _h[Translation.RequestTranscriptButton] = "Email transcript",
        _h[Translation.Cancel] = "Annulleren",
        _h[Translation.Submit] = "Verzenden",
        _h[Translation.RequestTranscriptModalTitle] = "Vraag transcript aan",
        _h[Translation.FormError] = "Corrigeer aub de fouten op het formulier om door te gaan.",
        _h[Translation.EndChatModalMessage] = "Weet u zeker dat u de chat wilt beëindigen?",
        _h[Translation.ViewChat] = "Bekijk transcript",
        _h[Translation.Typing] = "Aan het typen",
        _h[Translation.ErrorInvalid] = "Ongeldig",
        _h[Translation.TranscriptRequested] = "Transcript aangevraagd",
        _h[Translation.RequestTranscriptEmailLabel] = "Uw emailadres",
        _h[Translation.Yes] = "Ja",
        _h[Translation.BlockedAttachmentTitle] = "Bijlagen geblokkeerd",
        _h[Translation.AgentIsTyping] = "De medewerker typt...",
        _h[Translation.EndChatButton] = "Beëindig chat",
        _h[Translation.SkipSurvey] = "Sla feedback over",
        _h[Translation.ErrorRequired] = "Verplicht",
        _h[Translation.NewChat] = "Nieuwe chat",
        _h[Translation.GoToSurvey] = "Beoordeel uw ervaring",
        _h[Translation.ChatInputPlaceholder] = "Uw bericht ...",
        _h[Translation.Mute] = "Mute-meldingsgeluiden",
        _h[Translation.FinishedChatMoreOptions] = "Meer opties",
        _h[Translation.EmailTranscript] = "Email transcript",
        _h[Translation.CloseWindow] = "Close chat window",
        _h[Translation.Title] = "Help",
        _h[Translation.TooEarly] = "Ongeldig",
        _h[Translation.TooLate] = "Ongeldig",
        _h[Translation.TryingReconnect] = "Probeert opnieuw te verbinden",
        _h[Translation.Back] = "Terug",
        _h[Translation.StartChat] = "Begin chat",
        _h[Translation.EndChatModalTitle] = "Chat eindigen",
        _h[Translation.MinimiseWindow] = "Verklein chat venster",
        _h[Translation.PrintTranscriptButton] = "Transcript printen",
        _h[Translation.DownloadTranscriptButton] = "Transcript downloaden",
        _h[Translation.EmptySelect] = "Niets geselecteerd",
        _h[Translation.NoItemsFound] = "Geen resultaten gevonden",
        _h[Translation.TypeToSearch] = "Zoeken…",
        _h),
    _a[Language.Swedish] = (_j = {},
        _j[Translation.ChatEnded] = "Denna Chatt har avslutats",
        _j[Translation.ChangeLanguage] = "Ändra språk",
        _j[Translation.SurveyThanks] = "Tack för din feedback.",
        _j[Translation.Unmute] = "Sätt på notifikationssignalen",
        _j[Translation.OpenChat] = "Öppna Chat Support",
        _j[Translation.Error] = "Fel",
        _j[Translation.BlockedAttachmentMessage] = "Aktivera popup-fönster i din webbläsare för att se den här bilagan",
        _j[Translation.RequestTranscriptButton] = "Skicka transkript via epost",
        _j[Translation.Cancel] = "Annullera",
        _j[Translation.Submit] = "Bekräfta",
        _j[Translation.RequestTranscriptModalTitle] = "Begär transkript",
        _j[Translation.FormError] = "Fixa felen på formuläret för att fortsätta.",
        _j[Translation.EndChatModalMessage] = "Är du säker på att du vill avsluta Chatten?",
        _j[Translation.ViewChat] = "Se transkript",
        _j[Translation.Typing] = "Skriver",
        _j[Translation.ErrorInvalid] = "Ogiltig",
        _j[Translation.TranscriptRequested] = "Transkript har begärts",
        _j[Translation.RequestTranscriptEmailLabel] = "Din epost adress",
        _j[Translation.Yes] = "Ja",
        _j[Translation.BlockedAttachmentTitle] = "Bilagor blockerade",
        _j[Translation.AgentIsTyping] = "Agenten skriver ...",
        _j[Translation.EndChatButton] = "Avsluta Chatten",
        _j[Translation.SkipSurvey] = "Skippa Feedback",
        _j[Translation.ErrorRequired] = "Nödvändig",
        _j[Translation.NewChat] = "Ny Chatt",
        _j[Translation.GoToSurvey] = "Betygsätta din upplevelse",
        _j[Translation.ChatInputPlaceholder] = "Ditt meddelande",
        _j[Translation.Mute] = "Sätt notifikationssignalen på ljudlös",
        _j[Translation.FinishedChatMoreOptions] = "Fler alternativ",
        _j[Translation.EmailTranscript] = "Chatt transkript",
        _j[Translation.CloseWindow] = "Close chat window",
        _j[Translation.Title] = "Hjälp",
        _j[Translation.TooEarly] = "Ogiltig",
        _j[Translation.TooLate] = "Ogiltig",
        _j[Translation.TryingReconnect] = "Försöker återansluta",
        _j[Translation.Back] = "Tillbaka",
        _j[Translation.StartChat] = "Starta chatt",
        _j[Translation.EndChatModalTitle] = "Avlsuta Chatt",
        _j[Translation.MinimiseWindow] = "Minimera chattfönstret",
        _j[Translation.PrintTranscriptButton] = "Printa kopia",
        _j[Translation.DownloadTranscriptButton] = "Ladda ner kopia",
        _j[Translation.EmptySelect] = "Inget valt",
        _j[Translation.NoItemsFound] = "Inga resultat funna",
        _j[Translation.TypeToSearch] = "Sök...",
        _j),
    _a[Language.Polish] = (_k = {},
        _k[Translation.ChatEnded] = "Czat zakonczony",
        _k[Translation.ChangeLanguage] = "Zmien jezyk",
        _k[Translation.SurveyThanks] = "Dziekujemy za feedback",
        _k[Translation.Unmute] = "Wlacz dzwieki powiadomien",
        _k[Translation.OpenChat] = "Otworz Czat",
        _k[Translation.Error] = "Blad",
        _k[Translation.BlockedAttachmentMessage] = "Prosze wlaczyc pop-upy w przrgladarce aby zobaczyc ten zalacznik.",
        _k[Translation.RequestTranscriptButton] = "Zapis emaila",
        _k[Translation.Cancel] = "Anuluj",
        _k[Translation.Submit] = "Zatwierdz",
        _k[Translation.RequestTranscriptModalTitle] = "Popros o zapis",
        _k[Translation.FormError] = "Aby kontynuowac, prosimy poprawic bledy w formularzu",
        _k[Translation.EndChatModalMessage] = "Czy na pewno chcesz zakonczyc czat?",
        _k[Translation.ViewChat] = "Zobacz zapis czatu",
        _k[Translation.Typing] = "Pisze wiadomosc",
        _k[Translation.ErrorInvalid] = "Niewazny",
        _k[Translation.TranscriptRequested] = "Wyspanie zapytania o zapis",
        _k[Translation.RequestTranscriptEmailLabel] = "Twoj email",
        _k[Translation.Yes] = "Tak",
        _k[Translation.BlockedAttachmentTitle] = "Zalaczniki zablokowane",
        _k[Translation.AgentIsTyping] = "Agent pisze wiadomosc...",
        _k[Translation.EndChatButton] = "Zakoncz czat",
        _k[Translation.SkipSurvey] = "Omin feedback",
        _k[Translation.ErrorRequired] = "Wymagany",
        _k[Translation.NewChat] = "Nowy czat",
        _k[Translation.GoToSurvey] = "Podziel się opinią",
        _k[Translation.ChatInputPlaceholder] = "Twoja wiadomosc...",
        _k[Translation.Mute] = "Wycisz dzwieki powiadomien",
        _k[Translation.FinishedChatMoreOptions] = "Więcej opcji",
        _k[Translation.EmailTranscript] = "Zapis emaila",
        _k[Translation.CloseWindow] = "Close chat window",
        _k[Translation.Title] = "Pomoc",
        _k[Translation.TooEarly] = "Niewazny",
        _k[Translation.TooLate] = "Niewazny",
        _k[Translation.TryingReconnect] = "Uzyskiwanie polaczenie",
        _k[Translation.Back] = "Wstecz",
        _k[Translation.StartChat] = "Rozpocznij czat",
        _k[Translation.EndChatModalTitle] = "Zakoncz czas",
        _k[Translation.MinimiseWindow] = "Zminimalizuj okno czatu",
        _k[Translation.PrintTranscriptButton] = "Wydrukuj tranksrypcję",
        _k[Translation.DownloadTranscriptButton] = "Pobierz transkrypcję",
        _k[Translation.EmptySelect] = "Nie wybrano żadnej opcji.",
        _k[Translation.NoItemsFound] = "Brak wyników wyszukiwania. ",
        _k[Translation.TypeToSearch] = "Szukaj...",
        _k),
    _a[Language.Russian] = (_l = {},
        _l[Translation.ChatEnded] = "Чат закончен",
        _l[Translation.ChangeLanguage] = "Изменить язык",
        _l[Translation.SurveyThanks] = "Спасибо за Ваш отзыв",
        _l[Translation.Unmute] = "Включить звук уведомлений",
        _l[Translation.OpenChat] = "Открыть чат",
        _l[Translation.Error] = "Ошибка",
        _l[Translation.BlockedAttachmentMessage] = "Пожалуйста, включите появляющиеся окна в Вашем браузере, чтобы просмотреть эти вложения",
        _l[Translation.RequestTranscriptButton] = "Выслать стенограмму на электронный адрес",
        _l[Translation.Cancel] = "Отменить",
        _l[Translation.Submit] = "Отправить",
        _l[Translation.RequestTranscriptModalTitle] = "Запросить стенограмму",
        _l[Translation.FormError] = "Пожалуйста, исправьте ошибки в форме, чтобы продолжить.",
        _l[Translation.EndChatModalMessage] = "Вы действительно хотите закончить чат?",
        _l[Translation.ViewChat] = "Смотреть стенограмму",
        _l[Translation.Typing] = "Написание",
        _l[Translation.ErrorInvalid] = "Недействительно",
        _l[Translation.TranscriptRequested] = "Стенограмма запрошена",
        _l[Translation.RequestTranscriptEmailLabel] = "Адрес Вашей электронной почты",
        _l[Translation.Yes] = "Да",
        _l[Translation.BlockedAttachmentTitle] = "Вложения заблокированы",
        _l[Translation.AgentIsTyping] = "Агент печатает",
        _l[Translation.EndChatButton] = "Кнопка завершения чата",
        _l[Translation.SkipSurvey] = "Пропустить отзыв",
        _l[Translation.ErrorRequired] = "Обязательно",
        _l[Translation.NewChat] = "Новый чат",
        _l[Translation.GoToSurvey] = "Оцените ваш опыт",
        _l[Translation.ChatInputPlaceholder] = "Заполнитель чата",
        _l[Translation.Mute] = "Выключить звук уведомлений",
        _l[Translation.FinishedChatMoreOptions] = "Другие варианты",
        _l[Translation.EmailTranscript] = "Выслать стенограмму на электронный адрес",
        _l[Translation.CloseWindow] = "Close chat window",
        _l[Translation.Title] = "Помощь",
        _l[Translation.TooEarly] = "Недействительно",
        _l[Translation.TooLate] = "Недействительно",
        _l[Translation.TryingReconnect] = "Попытка соединения",
        _l[Translation.Back] = "Назад",
        _l[Translation.StartChat] = "Начать чат",
        _l[Translation.EndChatModalTitle] = "Закончить чат",
        _l[Translation.MinimiseWindow] = "Свернуть окно",
        _l[Translation.PrintTranscriptButton] = "Распечатка стенограммы",
        _l[Translation.DownloadTranscriptButton] = "Скачать стенограмму",
        _l[Translation.EmptySelect] = "Ничего не выбрано",
        _l[Translation.NoItemsFound] = "Результаты не найдены",
        _l[Translation.TypeToSearch] = "Поиск…",
        _l),
    _a[Language.Portuguese] = (_m = {},
        _m[Translation.ChatEnded] = "O chat terminou",
        _m[Translation.ChangeLanguage] = "Trocar língua",
        _m[Translation.SurveyThanks] = "Obrigado pelo seu feedback",
        _m[Translation.Unmute] = "Ativar sons the notificacao",
        _m[Translation.OpenChat] = "Abrir Suporte por Chat",
        _m[Translation.Error] = "Erro",
        _m[Translation.BlockedAttachmentMessage] = "Por favor, habilite os pop-ups em seu navegador para ver este anexo.",
        _m[Translation.RequestTranscriptButton] = "Transcricao de email",
        _m[Translation.Cancel] = "Cancelar",
        _m[Translation.Submit] = "Enviar",
        _m[Translation.RequestTranscriptModalTitle] = "Solicitar transcricao",
        _m[Translation.FormError] = "Por favor, corrija os erros no formulário para continuar.",
        _m[Translation.EndChatModalMessage] = "Voce tem certeza que deseja finalizar o chat?",
        _m[Translation.ViewChat] = "Ver transcricao do chat",
        _m[Translation.Typing] = "Digitando",
        _m[Translation.ErrorInvalid] = "Erro/Invalido",
        _m[Translation.TranscriptRequested] = "Transcricao solicitada",
        _m[Translation.RequestTranscriptEmailLabel] = "Seu endereco de email",
        _m[Translation.Yes] = "Sim",
        _m[Translation.BlockedAttachmentTitle] = "Anexo bloqueado",
        _m[Translation.AgentIsTyping] = "Agenten skriver...",
        _m[Translation.EndChatButton] = "Terminar Chat",
        _m[Translation.SkipSurvey] = "Pular feedback",
        _m[Translation.ErrorRequired] = "Erro/Obrigatorio",
        _m[Translation.NewChat] = "Novo chat",
        _m[Translation.GoToSurvey] = "Avalie sua experiência",
        _m[Translation.ChatInputPlaceholder] = "Sua mensagem...",
        _m[Translation.Mute] = "Silenciar sons the notificacao",
        _m[Translation.FinishedChatMoreOptions] = "Mais opções",
        _m[Translation.EmailTranscript] = "Transcricao de email",
        _m[Translation.CloseWindow] = "Close chat window",
        _m[Translation.Title] = "Ajuda",
        _m[Translation.TooEarly] = "Erro/Invalido",
        _m[Translation.TooLate] = "Erro/Invalido",
        _m[Translation.TryingReconnect] = "Tentando reconectar",
        _m[Translation.Back] = "Voltar",
        _m[Translation.StartChat] = "Iniciar bate-papo",
        _m[Translation.EndChatModalTitle] = "Fim do chat",
        _m[Translation.MinimiseWindow] = "Minimizar a janela do Chat",
        _m[Translation.PrintTranscriptButton] = "Imprimir a transcrição.",
        _m[Translation.DownloadTranscriptButton] = "Baixar a transcrição.",
        _m[Translation.EmptySelect] = "Nenhum criterio foi seleccionado",
        _m[Translation.NoItemsFound] = "Sem resultado",
        _m[Translation.TypeToSearch] = "Procurar...",
        _m),
    _a[Language.Norwegian] = (_o = {},
        _o[Translation.ChatEnded] = "Chatten er avsluttet.",
        _o[Translation.ChangeLanguage] = "Endre språk",
        _o[Translation.SurveyThanks] = "Takk for din tilbakemelding.",
        _o[Translation.Unmute] = "Slå av lyden for varsling",
        _o[Translation.OpenChat] = "Åpne Chat Support",
        _o[Translation.Error] = "Feil",
        _o[Translation.BlockedAttachmentMessage] = "Vennligst tillatt pop-ups i din nettleser for å se vedlegget.",
        _o[Translation.RequestTranscriptButton] = "Send kopi på e-post",
        _o[Translation.Cancel] = "Kanseller",
        _o[Translation.Submit] = "Send",
        _o[Translation.RequestTranscriptModalTitle] = "Be om kopi",
        _o[Translation.FormError] = "Vennligst fiks feilen i skjemaet for å fortsette",
        _o[Translation.EndChatModalMessage] = "Er du sikker på at du vil avslutte chatten?",
        _o[Translation.ViewChat] = "Se kopi av Chat",
        _o[Translation.Typing] = "Skriver",
        _o[Translation.ErrorInvalid] = "Ikke Gyldig",
        _o[Translation.TranscriptRequested] = "Forespørsel om kopi sendt",
        _o[Translation.RequestTranscriptEmailLabel] = "Din e-post adresse",
        _o[Translation.Yes] = "Ja",
        _o[Translation.BlockedAttachmentTitle] = "Vedlegg blokkert",
        _o[Translation.AgentIsTyping] = "Agenten skriver...",
        _o[Translation.EndChatButton] = "Avslutt Chatten",
        _o[Translation.SkipSurvey] = "Hopp Over Tilbakemelding",
        _o[Translation.ErrorRequired] = "Nødvendig",
        _o[Translation.NewChat] = "Ny Chat",
        _o[Translation.GoToSurvey] = "Vurder din opplevelse",
        _o[Translation.ChatInputPlaceholder] = "Din melding",
        _o[Translation.Mute] = "Dempende varsling lyder",
        _o[Translation.FinishedChatMoreOptions] = "Flere alternativ",
        _o[Translation.EmailTranscript] = "Send kopi på e-post",
        _o[Translation.CloseWindow] = "Close chat window",
        _o[Translation.Title] = "Hjelp",
        _o[Translation.TooEarly] = "Ikke Gyldig",
        _o[Translation.TooLate] = "Ikke Gyldig",
        _o[Translation.TryingReconnect] = "Forsøker å koble til igjen",
        _o[Translation.Back] = "Tilbake",
        _o[Translation.StartChat] = "Start chat",
        _o[Translation.EndChatModalTitle] = "Avslutt Chat",
        _o[Translation.MinimiseWindow] = "Minimer chatvinduet",
        _o[Translation.PrintTranscriptButton] = "Print kopi",
        _o[Translation.DownloadTranscriptButton] = "Last ned kopi",
        _o[Translation.EmptySelect] = "Ingenting valgt",
        _o[Translation.NoItemsFound] = "Fant ingen resultater",
        _o[Translation.TypeToSearch] = "Søk...",
        _o),
    _a[Language.Turkish] = (_p = {},
        _p[Translation.ChatEnded] = "Chat sona erdi.",
        _p[Translation.ChangeLanguage] = "Dili Değiştir",
        _p[Translation.SurveyThanks] = "Geri bildiriminiz için teşekkür ederiz.",
        _p[Translation.Unmute] = "Bildirim seslerini aç",
        _p[Translation.OpenChat] = "sohbet desteğini aç",
        _p[Translation.Error] = "Hata",
        _p[Translation.BlockedAttachmentMessage] = "Bu eki görüntülemek için lütfen tarayıcınızdaki açılır pencereleri etkinleştirin.",
        _p[Translation.RequestTranscriptButton] = "Transkript İste",
        _p[Translation.Cancel] = "İptal",
        _p[Translation.Submit] = "Onayla",
        _p[Translation.RequestTranscriptModalTitle] = "Transkript İste",
        _p[Translation.FormError] = "Devam etmek için lütfen formdaki hataları düzeltin",
        _p[Translation.EndChatModalMessage] = "Sohbeti bitirmek istediğinize emin misiniz?",
        _p[Translation.ViewChat] = "Sohbeti Göster",
        _p[Translation.Typing] = "Yazıyor",
        _p[Translation.ErrorInvalid] = "Geçersiz",
        _p[Translation.TranscriptRequested] = "Transkript Talep Edildi",
        _p[Translation.RequestTranscriptEmailLabel] = "E-post adresiniz",
        _p[Translation.Yes] = "Evet",
        _p[Translation.BlockedAttachmentTitle] = "Ek Blokelendi",
        _p[Translation.AgentIsTyping] = "Temsilci yazıyor...",
        _p[Translation.EndChatButton] = "Canlı Sohbeti Sonlandır",
        _p[Translation.SkipSurvey] = "Anketi Atla",
        _p[Translation.ErrorRequired] = "Gerekli",
        _p[Translation.NewChat] = "Yeni Sohbet",
        _p[Translation.GoToSurvey] = "Deneyiminizi değerlendirin",
        _p[Translation.ChatInputPlaceholder] = "Mesajınız...",
        _p[Translation.Mute] = "Bildirim sesini kapat",
        _p[Translation.FinishedChatMoreOptions] = "Daha fazla seçenek",
        _p[Translation.EmailTranscript] = "E-posta Transkripti",
        _p[Translation.CloseWindow] = "Close chat window",
        _p[Translation.Title] = "Yardım",
        _p[Translation.TooEarly] = "Geçersiz",
        _p[Translation.TooLate] = "Geçersiz",
        _p[Translation.TryingReconnect] = "Yeniden Bağlanıyor",
        _p[Translation.Back] = "Geri",
        _p[Translation.StartChat] = "Sohbeti başlat",
        _p[Translation.EndChatModalTitle] = "Sohbeti Sonlandır",
        _p[Translation.MinimiseWindow] = "Canlı Sohbet Penceresini Küçült",
        _p[Translation.PrintTranscriptButton] = "Transkripti Yazdır",
        _p[Translation.DownloadTranscriptButton] = "Transkripti İndir",
        _p[Translation.EmptySelect] = "Hiçbir şey seçilmedi",
        _p[Translation.NoItemsFound] = "Hiçbir sonuç bulunamadı",
        _p[Translation.TypeToSearch] = "Arama...",
        _p),
    _a[Language.Thai] = (_q = {},
        _q[Translation.ChatEnded] = "แชทได้สิ้นสุดลงแล้ว",
        _q[Translation.ChangeLanguage] = "เปลี่ยนภาษา",
        _q[Translation.SurveyThanks] = "ขอบคุณสำหรับความคิดเห็นของคุณ",
        _q[Translation.Unmute] = "เปิดเสียงปิดเสียงเตือน",
        _q[Translation.OpenChat] = "เปิดการสนับสนุนการแชท",
        _q[Translation.Error] = "ความผิดพลาด",
        _q[Translation.BlockedAttachmentMessage] = "โปรดเปิดใช้งานป๊อปอัพในเบราว์เซอร์ของคุณเพื่อดูสิ่งที่แนบมานี้",
        _q[Translation.RequestTranscriptButton] = "Transcript อีเมล์",
        _q[Translation.Cancel] = "ยกเลิก",
        _q[Translation.Submit] = "เสนอ",
        _q[Translation.RequestTranscriptModalTitle] = "ที่ขอ Transcript",
        _q[Translation.FormError] = "โปรดแก้ไขข้อผิดพลาดในแบบฟอร์มเพื่อดำเนินการต่อ",
        _q[Translation.EndChatModalMessage] = "คุณแน่ใจหรือไม่ว่าต้องการที่จะจบการสนทนา?",
        _q[Translation.ViewChat] = "ดู Transcript",
        _q[Translation.Typing] = "การพิมพ์",
        _q[Translation.ErrorInvalid] = "โมฆะ",
        _q[Translation.TranscriptRequested] = "Transcript ขอ",
        _q[Translation.RequestTranscriptEmailLabel] = "ที่อยู่อีเมลของคุณ",
        _q[Translation.Yes] = "ใช่",
        _q[Translation.BlockedAttachmentTitle] = "สิ่งที่แนบมา ถูกบล็อก",
        _q[Translation.AgentIsTyping] = "เจ้าหน้าที่กำลังพิมพ์...",
        _q[Translation.EndChatButton] = "ปิดแชต",
        _q[Translation.SkipSurvey] = "ข้ามการสำรวจ",
        _q[Translation.ErrorRequired] = "จำเป็นต้องใช้",
        _q[Translation.NewChat] = "แชทใหม่",
        _q[Translation.GoToSurvey] = "เรทประสบการณ์ของคุณ",
        _q[Translation.ChatInputPlaceholder] = "ข้อความของคุณ...",
        _q[Translation.Mute] = "ปิดเสียงการแจ้งเตือน",
        _q[Translation.FinishedChatMoreOptions] = "ข้อเลือกเพิ่มเติม",
        _q[Translation.EmailTranscript] = "Transcript อีเมล์",
        _q[Translation.CloseWindow] = "Close chat window",
        _q[Translation.Title] = "ช่วยด้วย",
        _q[Translation.TooEarly] = "โมฆะ",
        _q[Translation.TooLate] = "โมฆะ",
        _q[Translation.TryingReconnect] = "พยายามที่จะเชื่อมต่อ",
        _q[Translation.Back] = "กลับ",
        _q[Translation.StartChat] = "เริ่มแชทใหม่",
        _q[Translation.EndChatModalTitle] = "จบการพูดคุย",
        _q[Translation.MinimiseWindow] = "ปิดหน้าต่างแชต",
        _q[Translation.PrintTranscriptButton] = "พิมพ์ทรานสคริปต์",
        _q[Translation.DownloadTranscriptButton] = "ดาวน์โหลดทรานสคริปต์",
        _q[Translation.EmptySelect] = "ไม่ได้เลือกรายการใด",
        _q[Translation.NoItemsFound] = "ไม่พบผลการค้นหา",
        _q[Translation.TypeToSearch] = "ค้นหา...",
        _q),
    _a[Language.Bosnian] = (_r = {},
        _r[Translation.ChatEnded] = "Razgovor je završen",
        _r[Translation.ChangeLanguage] = "Promijenite jezik",
        _r[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _r[Translation.Unmute] = "Uključi zvukove obavijesti",
        _r[Translation.OpenChat] = "Podrška za otvoreni chat",
        _r[Translation.Error] = "Pogreška",
        _r[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _r[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _r[Translation.Cancel] = "Otkazati",
        _r[Translation.Submit] = "Podnijeti",
        _r[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _r[Translation.FormError] = "Ispravite greške na obrascu da biste nastavili",
        _r[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _r[Translation.ViewChat] = "Pogledaj prijepis",
        _r[Translation.Typing] = "Tipkanje",
        _r[Translation.ErrorInvalid] = "Nevažeći",
        _r[Translation.TranscriptRequested] = "Prijepis zatražen",
        _r[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _r[Translation.Yes] = "Da",
        _r[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _r[Translation.AgentIsTyping] = "Agent kuca...",
        _r[Translation.EndChatButton] = "Kraj chata",
        _r[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _r[Translation.ErrorRequired] = "Potreban",
        _r[Translation.NewChat] = "Novi razgovor",
        _r[Translation.GoToSurvey] = "Ocijenite Vaše iskustvo",
        _r[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _r[Translation.Mute] = "Priguši zvukove obavijesti",
        _r[Translation.FinishedChatMoreOptions] = "Više opcija",
        _r[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _r[Translation.CloseWindow] = "Close chat window",
        _r[Translation.Title] = "Pomoć",
        _r[Translation.TooEarly] = "Nevažeći",
        _r[Translation.TooLate] = "Nevažeći",
        _r[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _r[Translation.Back] = "Natrag",
        _r[Translation.StartChat] = "Započni razgovor",
        _r[Translation.EndChatModalTitle] = "Završetak razgovora",
        _r[Translation.MinimiseWindow] = "Smanjite prozor za chat",
        _r[Translation.PrintTranscriptButton] = "Print Transcript",
        _r[Translation.DownloadTranscriptButton] = "Download Transcript",
        _r[Translation.EmptySelect] = "Nothing selected",
        _r[Translation.NoItemsFound] = "No results found",
        _r[Translation.TypeToSearch] = "Search...",
        _r),
    _a[Language.Serbian] = (_s = {},
        _s[Translation.ChatEnded] = "Razgovor je završen",
        _s[Translation.ChangeLanguage] = "Promenite jezik",
        _s[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _s[Translation.Unmute] = "Uključi zvukove novosti",
        _s[Translation.OpenChat] = "Podrška za otvoreno časkanje",
        _s[Translation.Error] = "Pogreška",
        _s[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _s[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _s[Translation.Cancel] = "Otkazati",
        _s[Translation.Submit] = "Podnijeti",
        _s[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _s[Translation.FormError] = "Ispravite pogreške na obrascu da biste nastavili",
        _s[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _s[Translation.ViewChat] = "Pogledaj prijepis",
        _s[Translation.Typing] = "Tipkanje",
        _s[Translation.ErrorInvalid] = "Nevažeći",
        _s[Translation.TranscriptRequested] = "Prijepis zatražen",
        _s[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _s[Translation.Yes] = "Da",
        _s[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _s[Translation.AgentIsTyping] = "Agent kuca...",
        _s[Translation.EndChatButton] = "Kraj časkanja",
        _s[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _s[Translation.ErrorRequired] = "Potreban",
        _s[Translation.NewChat] = "Novi razgovor",
        _s[Translation.GoToSurvey] = "Ocenite Vaše iskustvo",
        _s[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _s[Translation.Mute] = "Priguši zvukove novosti",
        _s[Translation.FinishedChatMoreOptions] = "Više opcija",
        _s[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _s[Translation.CloseWindow] = "Close chat window",
        _s[Translation.Title] = "Pomoć",
        _s[Translation.TooEarly] = "Nevažeći",
        _s[Translation.TooLate] = "Nevažeći",
        _s[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _s[Translation.Back] = "Natrag",
        _s[Translation.StartChat] = "Započni razgovor",
        _s[Translation.EndChatModalTitle] = "Završetak razgovora",
        _s[Translation.MinimiseWindow] = "Minimizirajte prozor za časkanje",
        _s[Translation.PrintTranscriptButton] = "Print Transcript",
        _s[Translation.DownloadTranscriptButton] = "Download Transcript",
        _s[Translation.EmptySelect] = "Nothing selected",
        _s[Translation.NoItemsFound] = "No results found",
        _s[Translation.TypeToSearch] = "Search...",
        _s),
    _a[Language.Croatian] = (_t = {},
        _t[Translation.ChatEnded] = "Razgovor je završen",
        _t[Translation.ChangeLanguage] = "Promijenite jezik",
        _t[Translation.SurveyThanks] = "Zahvaljujemo Vam na povratnoj informaciji",
        _t[Translation.Unmute] = "Uključi zvukove obavijesti",
        _t[Translation.OpenChat] = "Podrška za otvoreni chat",
        _t[Translation.Error] = "Pogreška",
        _t[Translation.BlockedAttachmentMessage] = "Molimo dopustite skočne prozore u Vašem izborniku da biste vidjeli privitak",
        _t[Translation.RequestTranscriptButton] = "Prijepis elektronske pošte",
        _t[Translation.Cancel] = "Otkazati",
        _t[Translation.Submit] = "Podnijeti",
        _t[Translation.RequestTranscriptModalTitle] = "Zahtjev za prijepisom",
        _t[Translation.FormError] = "Ispravite greške na obrascu da biste nastavili",
        _t[Translation.EndChatModalMessage] = "Da li ste sigurni da želite završiti razgovor?",
        _t[Translation.ViewChat] = "Pogledaj prijepis",
        _t[Translation.Typing] = "Tipkanje",
        _t[Translation.ErrorInvalid] = "Nevažeći",
        _t[Translation.TranscriptRequested] = "Prijepis zatražen",
        _t[Translation.RequestTranscriptEmailLabel] = "Vaša adresa elektronske pošte",
        _t[Translation.Yes] = "Da",
        _t[Translation.BlockedAttachmentTitle] = "Privici blokirani",
        _t[Translation.AgentIsTyping] = "Agent piše...",
        _t[Translation.EndChatButton] = "Završetak chata",
        _t[Translation.SkipSurvey] = "Preskoči povratnu informaciju",
        _t[Translation.ErrorRequired] = "Potreban",
        _t[Translation.NewChat] = "Novi razgovor",
        _t[Translation.GoToSurvey] = "Ocijenite Vaše iskustvo",
        _t[Translation.ChatInputPlaceholder] = "Vaša poruka...",
        _t[Translation.Mute] = "Utišaj zvukove obavijesti",
        _t[Translation.FinishedChatMoreOptions] = "Više opcija",
        _t[Translation.EmailTranscript] = "Prijepis elektronske pošte",
        _t[Translation.CloseWindow] = "Close chat window",
        _t[Translation.Title] = "Pomoć",
        _t[Translation.TooEarly] = "Nevažeći",
        _t[Translation.TooLate] = "Nevažeći",
        _t[Translation.TryingReconnect] = "Pokušavamo prespojiti",
        _t[Translation.Back] = "Natrag",
        _t[Translation.StartChat] = "Započni razgovor",
        _t[Translation.EndChatModalTitle] = "Završetak razgovora",
        _t[Translation.MinimiseWindow] = "Smanjite prozor za chat",
        _t[Translation.PrintTranscriptButton] = "Printaj prepisku",
        _t[Translation.DownloadTranscriptButton] = "Skini prepisku",
        _t[Translation.EmptySelect] = "Ništa nije odabrano",
        _t[Translation.NoItemsFound] = "Nisu pronađeni rezultati",
        _t[Translation.TypeToSearch] = "Pretražite...",
        _t),
    _a[Language.Romanian] = (_u = {},
        _u[Translation.ChatEnded] = "Chat-ul s-a încheiat.",
        _u[Translation.ChangeLanguage] = "Modificați limba",
        _u[Translation.SurveyThanks] = "Vă mulțumim pentru feedback-ul dumneavoastră.",
        _u[Translation.Unmute] = "Se anulează sunetele de notificare",
        _u[Translation.OpenChat] = "Deschideți Chat Support",
        _u[Translation.Error] = "Eroare",
        _u[Translation.BlockedAttachmentMessage] = "Activați opțiunea pop-up în browserul dvs. pentru a vizualiza acest atașament.",
        _u[Translation.RequestTranscriptButton] = "Trimite transcrierea pe e-mail",
        _u[Translation.Cancel] = "Anulează",
        _u[Translation.Submit] = "Trimite",
        _u[Translation.RequestTranscriptModalTitle] = "Solicită transcrierea",
        _u[Translation.FormError] = "Vă rugăm să remediați erorile din formular pentru a continua.",
        _u[Translation.EndChatModalMessage] = "Sigur doriți să încheiați chatul?",
        _u[Translation.ViewChat] = "Vizualizează transcrierea",
        _u[Translation.Typing] = "Scrie",
        _u[Translation.ErrorInvalid] = "Invalid",
        _u[Translation.TranscriptRequested] = "Transcript Requested",
        _u[Translation.RequestTranscriptEmailLabel] = "Adresa dvs. de e-mail",
        _u[Translation.Yes] = "Da",
        _u[Translation.BlockedAttachmentTitle] = "Atașamente blocate",
        _u[Translation.AgentIsTyping] = "Agentul scrie...",
        _u[Translation.EndChatButton] = "Terminați  conversația",
        _u[Translation.SkipSurvey] = "Nu doresc să trimit Feedback",
        _u[Translation.ErrorRequired] = "Solicitat",
        _u[Translation.NewChat] = "Un nou Chat",
        _u[Translation.GoToSurvey] = "Evaluați-vă experiența",
        _u[Translation.ChatInputPlaceholder] = "Mesajul dumneavoastră",
        _u[Translation.Mute] = "Sună notificarea mută",
        _u[Translation.FinishedChatMoreOptions] = "Mai multe opțiuni",
        _u[Translation.EmailTranscript] = "Trimite transcrierea pe e-mail",
        _u[Translation.CloseWindow] = "Close chat window",
        _u[Translation.Title] = "Asistență",
        _u[Translation.TooEarly] = "Invalid",
        _u[Translation.TooLate] = "Invalid",
        _u[Translation.TryingReconnect] = "Încercăm să vă reconectăm",
        _u[Translation.Back] = "Înapoi",
        _u[Translation.StartChat] = "Incepe conversatia",
        _u[Translation.EndChatModalTitle] = "Termină Chat",
        _u[Translation.MinimiseWindow] = "Minimizați fereastra de conversație",
        _u[Translation.PrintTranscriptButton] = "Tipărire transcriere",
        _u[Translation.DownloadTranscriptButton] = "Descărcare transcriere",
        _u[Translation.EmptySelect] = "Nimic selectat",
        _u[Translation.NoItemsFound] = "Nu au fost găsite rezultate",
        _u[Translation.TypeToSearch] = "Căutare...",
        _u),
    _a[Language.Catalan] = (_v = {},
        _v[Translation.ChatEnded] = "El xat ha finalitzat",
        _v[Translation.ChangeLanguage] = "Cambiar l'idioma",
        _v[Translation.SurveyThanks] = "Gràcies per la seva opinó",
        _v[Translation.Unmute] = "Activa els sons de notificació",
        _v[Translation.OpenChat] = "Iniciar el xat de suport",
        _v[Translation.Error] = "Error",
        _v[Translation.BlockedAttachmentMessage] = "Siusplau habiliti pop-ups al vostre navegador per veure aquest adjunt",
        _v[Translation.RequestTranscriptButton] = "Transcripció de correu electrònic",
        _v[Translation.Cancel] = "Cancelació",
        _v[Translation.Submit] = "Enviar",
        _v[Translation.RequestTranscriptModalTitle] = "Transcripció requerida",
        _v[Translation.FormError] = "Siusplau, solucioni els errors del formulari per a continuar",
        _v[Translation.EndChatModalMessage] = "Estàs segur de que vols finalitzar el xat?",
        _v[Translation.ViewChat] = "Veure transcripció",
        _v[Translation.Typing] = "Escrivint",
        _v[Translation.ErrorInvalid] = "Invàlid",
        _v[Translation.TranscriptRequested] = "Transcripció requerida",
        _v[Translation.RequestTranscriptEmailLabel] = "La seva direcció de correu electrònic",
        _v[Translation.Yes] = "Si",
        _v[Translation.BlockedAttachmentTitle] = "Adjunts blocats",
        _v[Translation.AgentIsTyping] = "L'agent esta escrivint",
        _v[Translation.EndChatButton] = "Finalitzar el xat",
        _v[Translation.SkipSurvey] = "Ignorar enquesta",
        _v[Translation.ErrorRequired] = "Requerit",
        _v[Translation.NewChat] = "Nou xat",
        _v[Translation.GoToSurvey] = "Valoreu la vostra experiència",
        _v[Translation.ChatInputPlaceholder] = "El teu missatge",
        _v[Translation.Mute] = "Sona la notificació en silenciar",
        _v[Translation.FinishedChatMoreOptions] = "Més opcions",
        _v[Translation.EmailTranscript] = "Transcripció de correu electrònic",
        _v[Translation.CloseWindow] = "Close chat window",
        _v[Translation.Title] = "Ajuda",
        _v[Translation.TooEarly] = "Invàlid",
        _v[Translation.TooLate] = "Invàlid",
        _v[Translation.TryingReconnect] = "Tractant de conectar de nou",
        _v[Translation.Back] = "Enrere",
        _v[Translation.StartChat] = "Inicia el xat",
        _v[Translation.EndChatModalTitle] = "Xat finalitzat",
        _v[Translation.MinimiseWindow] = "Minimitzar la finestra del xat",
        _v[Translation.PrintTranscriptButton] = "Imprimir la transcripció",
        _v[Translation.DownloadTranscriptButton] = "Descarregar la transcripció",
        _v[Translation.EmptySelect] = "No s’ha seleccionat res",
        _v[Translation.NoItemsFound] = "No s’han trobat resultats",
        _v[Translation.TypeToSearch] = "Cerca...",
        _v),
    _a[Language.Malay] = (_w = {},
        _w[Translation.ChatEnded] = "Sembang telah berakhir",
        _w[Translation.ChangeLanguage] = "Tukar Bahasa",
        _w[Translation.SurveyThanks] = "Terima kasih atas maklum balas anda.",
        _w[Translation.Unmute] = "Nyahaktifkan bunyi pemberitahuan",
        _w[Translation.OpenChat] = "sokongan sembang terbuka",
        _w[Translation.Error] = "Ralat",
        _w[Translation.BlockedAttachmentMessage] = "Sila aktifkan timbulan di pelayar anda untuk melihat lampiran ini",
        _w[Translation.RequestTranscriptButton] = "Transkrip e-mel",
        _w[Translation.Cancel] = "Batalkan",
        _w[Translation.Submit] = "Hantar",
        _w[Translation.RequestTranscriptModalTitle] = "Meminta transkrip",
        _w[Translation.FormError] = "Sila perbaiki ralat dalam borang untuk meneruskan",
        _w[Translation.EndChatModalMessage] = "Adakah anda pasti mahu menamatkan sembang?",
        _w[Translation.ViewChat] = "Lihat transkrip",
        _w[Translation.Typing] = "Menaip",
        _w[Translation.ErrorInvalid] = "Tidak sah",
        _w[Translation.TranscriptRequested] = "Transkrip yang diminta",
        _w[Translation.RequestTranscriptEmailLabel] = "Alamat e-mel anda",
        _w[Translation.Yes] = "Ya",
        _w[Translation.BlockedAttachmentTitle] = "Lampiran dihalangi",
        _w[Translation.AgentIsTyping] = "Agen sedang menaip...",
        _w[Translation.EndChatButton] = "Tamatkan Perbualan",
        _w[Translation.SkipSurvey] = "Langkau maklum balas",
        _w[Translation.ErrorRequired] = "Dikehendaki",
        _w[Translation.NewChat] = "Sembang Baru",
        _w[Translation.GoToSurvey] = "Kadar pengalaman anda",
        _w[Translation.ChatInputPlaceholder] = "Mesej anda...",
        _w[Translation.Mute] = "Bunyi pemberitahuan bisu",
        _w[Translation.FinishedChatMoreOptions] = "Pilihan yang banyak",
        _w[Translation.EmailTranscript] = "Transkrip e-mel",
        _w[Translation.CloseWindow] = "Close chat window",
        _w[Translation.Title] = "Bantuan",
        _w[Translation.TooEarly] = "Tidak sah",
        _w[Translation.TooLate] = "Tidak sah",
        _w[Translation.TryingReconnect] = "Cuba menyambung semula",
        _w[Translation.Back] = "Kembali",
        _w[Translation.StartChat] = "Mula sembang",
        _w[Translation.EndChatModalTitle] = "Tamat sembang",
        _w[Translation.MinimiseWindow] = "Kecilkan Tetingkap Perbualan",
        _w[Translation.PrintTranscriptButton] = "Cetak Transkrip",
        _w[Translation.DownloadTranscriptButton] = "Muat Turun Transkrip",
        _w[Translation.EmptySelect] = "Tiada satu pun dipilih",
        _w[Translation.NoItemsFound] = "Tiada hasil ditemui",
        _w[Translation.TypeToSearch] = "Cari...",
        _w),
    _a[Language.Finnish] = (_x = {},
        _x[Translation.ChatEnded] = "Chatti on päättynyt.",
        _x[Translation.ChangeLanguage] = "Vaihda kieltä",
        _x[Translation.SurveyThanks] = "Kiitos palautteestasi",
        _x[Translation.Unmute] = "Ohita ilmoitusäänet",
        _x[Translation.OpenChat] = "avoin chat-tuki",
        _x[Translation.Error] = "Virhe",
        _x[Translation.BlockedAttachmentMessage] = "Nähdäksesi liitteen, sinun tulee sallia selaimessasi ponnahdusikkunat",
        _x[Translation.RequestTranscriptButton] = "Lähetä keskustelu sähköpostiin",
        _x[Translation.Cancel] = "Peru",
        _x[Translation.Submit] = "Lähetä",
        _x[Translation.RequestTranscriptModalTitle] = "Pyydä kopio sähköpostiin",
        _x[Translation.FormError] = "Korjaa lomakkeella olevat virheet voidaksesi jatkaa",
        _x[Translation.EndChatModalMessage] = "Oletko varma, että haluat lopettaa chatin?",
        _x[Translation.ViewChat] = "Katso keskustelu",
        _x[Translation.Typing] = "Kirjoittaa",
        _x[Translation.ErrorInvalid] = "Virheellinen",
        _x[Translation.TranscriptRequested] = "Pyyntö lähetetty",
        _x[Translation.RequestTranscriptEmailLabel] = "Sähköpostiosoitteesi",
        _x[Translation.Yes] = "Kyllä",
        _x[Translation.BlockedAttachmentTitle] = "Liitteet estetty",
        _x[Translation.AgentIsTyping] = "Asiakaspalvelija kirjoittaa...",
        _x[Translation.EndChatButton] = "Lopeta chatti",
        _x[Translation.SkipSurvey] = "Ohita palaute",
        _x[Translation.ErrorRequired] = "Pakollinen",
        _x[Translation.NewChat] = "Uusi chatti",
        _x[Translation.GoToSurvey] = "Arvostele kokemuksesi",
        _x[Translation.ChatInputPlaceholder] = "Viestisi...",
        _x[Translation.Mute] = "Mykistä ilmoitus kuulostaa",
        _x[Translation.FinishedChatMoreOptions] = "Lisää vaihtoehtoja",
        _x[Translation.EmailTranscript] = "Lähetä keskustelu sähköpostiin",
        _x[Translation.CloseWindow] = "Close chat window",
        _x[Translation.Title] = "Tuki",
        _x[Translation.TooEarly] = "Virheellinen",
        _x[Translation.TooLate] = "Virheellinen",
        _x[Translation.TryingReconnect] = "Yritetään muodostaa uutta yhteyttä",
        _x[Translation.Back] = "Takaisin",
        _x[Translation.StartChat] = "Aloita chatti",
        _x[Translation.EndChatModalTitle] = "Lopeta chatti",
        _x[Translation.MinimiseWindow] = "Pienennä chatti-ikkuna",
        _x[Translation.PrintTranscriptButton] = "Tulosta selostus",
        _x[Translation.DownloadTranscriptButton] = "Lataa selostus",
        _x[Translation.EmptySelect] = "Mitään ei ole valittu",
        _x[Translation.NoItemsFound] = "Tuloksia ei löytynyt",
        _x[Translation.TypeToSearch] = "Hae...",
        _x),
    _a[Language.Japanese] = (_y = {},
        _y[Translation.ChatEnded] = "チャットは終了しました。",
        _y[Translation.ChangeLanguage] = "言語の変更",
        _y[Translation.SurveyThanks] = "ご意見をいただきありがとうございます。",
        _y[Translation.Unmute] = "ミュート解除通知音",
        _y[Translation.OpenChat] = "オープンチャットサポート",
        _y[Translation.Error] = "エラー",
        _y[Translation.BlockedAttachmentMessage] = "この添付ファイルを表示するには、ブラウザのポップアップを有効にしてください。",
        _y[Translation.RequestTranscriptButton] = "メールトランスクリプト",
        _y[Translation.Cancel] = "キャンセル",
        _y[Translation.Submit] = "提出する",
        _y[Translation.RequestTranscriptModalTitle] = "トランスクリプトを要求",
        _y[Translation.FormError] = "フォームのエラーを修正してから続けてください",
        _y[Translation.EndChatModalMessage] = "チャットを終了しますか",
        _y[Translation.ViewChat] = "トランスクリプトを見る",
        _y[Translation.Typing] = "タイピング",
        _y[Translation.ErrorInvalid] = "無効",
        _y[Translation.TranscriptRequested] = "要求された成績証明書",
        _y[Translation.RequestTranscriptEmailLabel] = "メールアドレス",
        _y[Translation.Yes] = "はい",
        _y[Translation.BlockedAttachmentTitle] = "ブロックされた添付ファイル",
        _y[Translation.AgentIsTyping] = "エージェントが入力しています...",
        _y[Translation.EndChatButton] = "チャットの終了",
        _y[Translation.SkipSurvey] = "フィードバックをスキップ",
        _y[Translation.ErrorRequired] = "必須",
        _y[Translation.NewChat] = "新しいチャット",
        _y[Translation.GoToSurvey] = "あなたの経験を評価する",
        _y[Translation.ChatInputPlaceholder] = "あなたのメッセージ...",
        _y[Translation.Mute] = "ミュート通知音",
        _y[Translation.FinishedChatMoreOptions] = "より多くのオプション",
        _y[Translation.EmailTranscript] = "メールトランスクリプト",
        _y[Translation.CloseWindow] = "Close chat window",
        _y[Translation.Title] = "チャットヘルプ",
        _y[Translation.TooEarly] = "無効",
        _y[Translation.TooLate] = "無効",
        _y[Translation.TryingReconnect] = "再接続しようとしています",
        _y[Translation.Back] = "戻り",
        _y[Translation.StartChat] = "チャットを始める",
        _y[Translation.EndChatModalTitle] = "チャットを終了",
        _y[Translation.MinimiseWindow] = "チャットウィンドウの最小化",
        _y[Translation.PrintTranscriptButton] = "チャットの内容を印刷",
        _y[Translation.DownloadTranscriptButton] = "チャットの内容をダウンロード",
        _y[Translation.EmptySelect] = "選択していません。",
        _y[Translation.NoItemsFound] = "該当するものがありません。",
        _y[Translation.TypeToSearch] = "検索中・・・",
        _y),
    _a[Language.Korean] = (_z = {},
        _z[Translation.ChatEnded] = "채팅이 종료 되었습니다.",
        _z[Translation.ChangeLanguage] = "언어 변경",
        _z[Translation.SurveyThanks] = "설문에 참여해 주셔서 감사합니다.",
        _z[Translation.Unmute] = "음소거 해제 알림 음",
        _z[Translation.OpenChat] = "열린 채팅 지원",
        _z[Translation.Error] = "오류",
        _z[Translation.BlockedAttachmentMessage] = "이 첨부 파일을 보려면 브라우저에서 팝업을 활성화하십시오.",
        _z[Translation.RequestTranscriptButton] = "이메일 기록",
        _z[Translation.Cancel] = "취소",
        _z[Translation.Submit] = "제출",
        _z[Translation.RequestTranscriptModalTitle] = "기록 요청하기",
        _z[Translation.FormError] = "양식에서 오류를 바로잡은 후 계속해주세요",
        _z[Translation.EndChatModalMessage] = "정말로 채팅을 끝내시겠습니까?",
        _z[Translation.ViewChat] = "채팅 기록(대화록) 보기",
        _z[Translation.Typing] = "입력중",
        _z[Translation.ErrorInvalid] = "유효하지 않음",
        _z[Translation.TranscriptRequested] = "기록 요청됨",
        _z[Translation.RequestTranscriptEmailLabel] = "고객님의 이메일 주소",
        _z[Translation.Yes] = "네",
        _z[Translation.BlockedAttachmentTitle] = "첨부 파일 거절됨",
        _z[Translation.AgentIsTyping] = "담당자가 입력 중...",
        _z[Translation.EndChatButton] = "상담 종료",
        _z[Translation.SkipSurvey] = "설문 건너뛰기",
        _z[Translation.ErrorRequired] = "요구됨",
        _z[Translation.NewChat] = "새로운 채팅",
        _z[Translation.GoToSurvey] = "고객님의 경험을 평가 해 주시겠습니까?",
        _z[Translation.ChatInputPlaceholder] = "내 메시지...",
        _z[Translation.Mute] = "알림 음소거",
        _z[Translation.FinishedChatMoreOptions] = "옵션 더 보기",
        _z[Translation.EmailTranscript] = "이메일 기록",
        _z[Translation.CloseWindow] = "Close chat window",
        _z[Translation.Title] = "도움",
        _z[Translation.TooEarly] = "유효하지 않음",
        _z[Translation.TooLate] = "유효하지 않음",
        _z[Translation.TryingReconnect] = "연결을 다시 시도하고 있습니다.",
        _z[Translation.Back] = "뒤로 가기",
        _z[Translation.StartChat] = "채팅 시작하기",
        _z[Translation.EndChatModalTitle] = "채팅 종료",
        _z[Translation.MinimiseWindow] = "상담창 최소화",
        _z[Translation.PrintTranscriptButton] = "채팅 내용 인쇄",
        _z[Translation.DownloadTranscriptButton] = "채팅 내용 다운로드",
        _z[Translation.EmptySelect] = "선택된 항목 없음",
        _z[Translation.NoItemsFound] = "결과를 찾을 수 없음",
        _z[Translation.TypeToSearch] = "검색...",
        _z),
    _a[Language.Chinese] = (_0 = {},
        _0[Translation.ChatEnded] = "聊天已经结束。",
        _0[Translation.ChangeLanguage] = "變更語言",
        _0[Translation.SurveyThanks] = "感谢您的反馈意见。",
        _0[Translation.Unmute] = "取消靜音通知聲音",
        _0[Translation.OpenChat] = "打开聊天支持",
        _0[Translation.Error] = "错误",
        _0[Translation.BlockedAttachmentMessage] = "请启用弹出式窗口在浏览器中查看该附件。",
        _0[Translation.RequestTranscriptButton] = "电子邮件成绩单",
        _0[Translation.Cancel] = "取消",
        _0[Translation.Submit] = "提交",
        _0[Translation.RequestTranscriptModalTitle] = "申请成绩单",
        _0[Translation.FormError] = "請修正表格上的錯誤以繼續",
        _0[Translation.EndChatModalMessage] = "你确定你想结束聊天？",
        _0[Translation.ViewChat] = "观看文稿",
        _0[Translation.Typing] = "打字",
        _0[Translation.ErrorInvalid] = "无效",
        _0[Translation.TranscriptRequested] = "成绩单请求",
        _0[Translation.RequestTranscriptEmailLabel] = "您的电子邮件地址",
        _0[Translation.Yes] = "是",
        _0[Translation.BlockedAttachmentTitle] = "附件阻止",
        _0[Translation.AgentIsTyping] = "專員正在輸入……",
        _0[Translation.EndChatButton] = "結束聊天",
        _0[Translation.SkipSurvey] = "跳过反馈",
        _0[Translation.ErrorRequired] = "需要",
        _0[Translation.NewChat] = "新的聊天室",
        _0[Translation.GoToSurvey] = "评价你的经验",
        _0[Translation.ChatInputPlaceholder] = "您的訊息……",
        _0[Translation.Mute] = "靜音通知聲音",
        _0[Translation.FinishedChatMoreOptions] = "更多的选择",
        _0[Translation.EmailTranscript] = "电子邮件成绩单",
        _0[Translation.CloseWindow] = "Close chat window",
        _0[Translation.Title] = "救命",
        _0[Translation.TooEarly] = "无效",
        _0[Translation.TooLate] = "无效",
        _0[Translation.TryingReconnect] = "正尝试重新连接",
        _0[Translation.Back] = "背部",
        _0[Translation.StartChat] = "开始聊天",
        _0[Translation.EndChatModalTitle] = "结束聊天",
        _0[Translation.MinimiseWindow] = "將聊天視窗最小化",
        _0[Translation.PrintTranscriptButton] = "打印脚本",
        _0[Translation.DownloadTranscriptButton] = "下载脚本",
        _0[Translation.EmptySelect] = "未选择任何内容",
        _0[Translation.NoItemsFound] = "未找到任何结果",
        _0[Translation.TypeToSearch] = "搜索...",
        _0),
    _a[Language.ChineseTaiwan] = (_1 = {},
        _1[Translation.ChatEnded] = "聊天已经结束。",
        _1[Translation.ChangeLanguage] = "變更語言",
        _1[Translation.SurveyThanks] = "感谢您的反馈意见。",
        _1[Translation.Unmute] = "取消靜音通知聲音",
        _1[Translation.OpenChat] = "打開聊天支持",
        _1[Translation.Error] = "错误",
        _1[Translation.BlockedAttachmentMessage] = "请启用弹出式窗口在浏览器中查看该附件。",
        _1[Translation.RequestTranscriptButton] = "电子邮件成绩单",
        _1[Translation.Cancel] = "取消",
        _1[Translation.Submit] = "提交",
        _1[Translation.RequestTranscriptModalTitle] = "申请成绩单",
        _1[Translation.FormError] = "請修正表格上的錯誤即可繼續",
        _1[Translation.EndChatModalMessage] = "你确定你想结束聊天？",
        _1[Translation.ViewChat] = "观看文稿",
        _1[Translation.Typing] = "打字",
        _1[Translation.ErrorInvalid] = "无效",
        _1[Translation.TranscriptRequested] = "成绩单请求",
        _1[Translation.RequestTranscriptEmailLabel] = "您的电子邮件地址",
        _1[Translation.Yes] = "是",
        _1[Translation.BlockedAttachmentTitle] = "附件阻止",
        _1[Translation.AgentIsTyping] = "服務人員正在輸入……",
        _1[Translation.EndChatButton] = "結束交談",
        _1[Translation.SkipSurvey] = "跳过反馈",
        _1[Translation.ErrorRequired] = "需要",
        _1[Translation.NewChat] = "新的聊天室",
        _1[Translation.GoToSurvey] = "评价你的经验",
        _1[Translation.ChatInputPlaceholder] = "您的訊息……",
        _1[Translation.Mute] = "靜音通知聲音",
        _1[Translation.FinishedChatMoreOptions] = "更多的选择",
        _1[Translation.EmailTranscript] = "电子邮件成绩单",
        _1[Translation.CloseWindow] = "Close chat window",
        _1[Translation.Title] = "救命",
        _1[Translation.TooEarly] = "无效",
        _1[Translation.TooLate] = "无效",
        _1[Translation.TryingReconnect] = "正尝试重新连接",
        _1[Translation.Back] = "背部",
        _1[Translation.StartChat] = "开始聊天",
        _1[Translation.EndChatModalTitle] = "结束聊天",
        _1[Translation.MinimiseWindow] = "將聊天室視窗最小化",
        _1[Translation.PrintTranscriptButton] = "列印聊天內容",
        _1[Translation.DownloadTranscriptButton] = "下載聊天內容",
        _1[Translation.EmptySelect] = "沒有選取項目",
        _1[Translation.NoItemsFound] = "無結果",
        _1[Translation.TypeToSearch] = "搜尋...",
        _1),
    _a[Language.Danish] = (_2 = {},
        _2[Translation.ChatEnded] = "Chat er afsluttet",
        _2[Translation.ChangeLanguage] = "Ændr sprog",
        _2[Translation.SurveyThanks] = "Tak for din tilbagemelding",
        _2[Translation.Unmute] = "Dæmp underretningslyde",
        _2[Translation.OpenChat] = "åben chat support",
        _2[Translation.Error] = "Forkert",
        _2[Translation.BlockedAttachmentMessage] = "Tillad popup-vinduer i din browser for at se vedhæftet fil.",
        _2[Translation.RequestTranscriptButton] = "Kopi af e-mail",
        _2[Translation.Cancel] = "Afbestille",
        _2[Translation.Submit] = "Indsend",
        _2[Translation.RequestTranscriptModalTitle] = "Anmod om en kopi",
        _2[Translation.FormError] = "Ret venligst fejlene i formularen for at fortsætte",
        _2[Translation.EndChatModalMessage] = "Er du sikker på, at du vil afslutte chatten?",
        _2[Translation.ViewChat] = "Se kopi",
        _2[Translation.Typing] = "skriver",
        _2[Translation.ErrorInvalid] = "Ikke gyldig",
        _2[Translation.TranscriptRequested] = "Forespørgsel sendt",
        _2[Translation.RequestTranscriptEmailLabel] = "Din e-mail adresse",
        _2[Translation.Yes] = "Ja",
        _2[Translation.BlockedAttachmentTitle] = "Vedhæftet fil blokeret",
        _2[Translation.AgentIsTyping] = "Medarbejder skriver ...",
        _2[Translation.EndChatButton] = "Afslut chat",
        _2[Translation.SkipSurvey] = "Spring over tibagemelding",
        _2[Translation.ErrorRequired] = "Nødvendigt",
        _2[Translation.NewChat] = "Ny chat",
        _2[Translation.GoToSurvey] = "Overvej din oplevelse",
        _2[Translation.ChatInputPlaceholder] = "Din besked ...",
        _2[Translation.Mute] = "Lyd om lydlyd",
        _2[Translation.FinishedChatMoreOptions] = "flere muligheder",
        _2[Translation.EmailTranscript] = "Send kopi via e-mail",
        _2[Translation.CloseWindow] = "Close chat window",
        _2[Translation.Title] = "Hjælp",
        _2[Translation.TooEarly] = "Ikke gyldig",
        _2[Translation.TooLate] = "Ikke gyldig",
        _2[Translation.TryingReconnect] = "Forsøger at genoprette forbindelse",
        _2[Translation.Back] = "tilbage",
        _2[Translation.StartChat] = "chat med os",
        _2[Translation.EndChatModalTitle] = "Afslut chat",
        _2[Translation.MinimiseWindow] = "Minimér chatvindue",
        _2[Translation.PrintTranscriptButton] = "Udskriv kopi",
        _2[Translation.DownloadTranscriptButton] = "Download kopi",
        _2[Translation.EmptySelect] = "Intet valgt",
        _2[Translation.NoItemsFound] = "Ingen resultater fundet",
        _2[Translation.TypeToSearch] = "Søg...",
        _2),
    _a[Language.Slovenian] = (_3 = {},
        _3[Translation.ChatEnded] = "Prekinitev spletnega pogovora",
        _3[Translation.ChangeLanguage] = "Spremeni jezik",
        _3[Translation.SurveyThanks] = "Hvala za Vaše mnenje",
        _3[Translation.Unmute] = "Vklopi se zvok obvestila",
        _3[Translation.OpenChat] = "odprta podpora za klepet",
        _3[Translation.Error] = "Napaka",
        _3[Translation.BlockedAttachmentMessage] = "Prosimo, če omogočite piškotke na Vašem spletnem brskalniku",
        _3[Translation.RequestTranscriptButton] = "Prepis spletne pošte",
        _3[Translation.Cancel] = "Razveljavi",
        _3[Translation.Submit] = "Potrdi",
        _3[Translation.RequestTranscriptModalTitle] = "Zahtevaj prepis",
        _3[Translation.FormError] = "Če želite nadaljevati, popravite napake v obrazcu",
        _3[Translation.EndChatModalMessage] = "Ali ste prepričani, da hočete prekiniti Vaš spletni pogovor",
        _3[Translation.ViewChat] = "Poglej prepis",
        _3[Translation.Typing] = "Tipkam",
        _3[Translation.ErrorInvalid] = "Neveljavno",
        _3[Translation.TranscriptRequested] = "Zahtevan prepis",
        _3[Translation.RequestTranscriptEmailLabel] = "Naslov spletne pošte",
        _3[Translation.Yes] = "Da",
        _3[Translation.BlockedAttachmentTitle] = "Neveljavna priponka",
        _3[Translation.AgentIsTyping] = "Zastopnik vnaša odgovor ...",
        _3[Translation.EndChatButton] = "Končaj klepet",
        _3[Translation.SkipSurvey] = "Preskoči",
        _3[Translation.ErrorRequired] = "Obvezno",
        _3[Translation.NewChat] = "Novi spletni pogovor",
        _3[Translation.GoToSurvey] = "Ocenite Vašo izkušnjo",
        _3[Translation.ChatInputPlaceholder] = "Vaše sporočilo ...",
        _3[Translation.Mute] = "Izključi zvok obvestila",
        _3[Translation.FinishedChatMoreOptions] = "Dodatno",
        _3[Translation.EmailTranscript] = "Prepis spletne pošte",
        _3[Translation.CloseWindow] = "Close chat window",
        _3[Translation.Title] = "Pomoč",
        _3[Translation.TooEarly] = "Neveljavno",
        _3[Translation.TooLate] = "Neveljavno",
        _3[Translation.TryingReconnect] = "Vzpostavljam povezavo",
        _3[Translation.Back] = "Nazaj",
        _3[Translation.StartChat] = "Začnite spletni pogovor",
        _3[Translation.EndChatModalTitle] = "Prekini spletni pogovor",
        _3[Translation.MinimiseWindow] = "Pomanjšaj okno za klepet",
        _3[Translation.PrintTranscriptButton] = "Print Transcript",
        _3[Translation.DownloadTranscriptButton] = "Download Transcript",
        _3[Translation.EmptySelect] = "Nothing selected",
        _3[Translation.NoItemsFound] = "No results found",
        _3[Translation.TypeToSearch] = "Search...",
        _3),
    _a[Language.Finnish] = (_4 = {},
        _4[Translation.ChatEnded] = "Chatti on päättynyt.",
        _4[Translation.ChangeLanguage] = "Vaihda kieltä",
        _4[Translation.SurveyThanks] = "Kiitos palautteestasi",
        _4[Translation.Unmute] = "Ohita ilmoitusäänet",
        _4[Translation.OpenChat] = "avoin chat-tuki",
        _4[Translation.Error] = "Virhe",
        _4[Translation.BlockedAttachmentMessage] = "Nähdäksesi liitteen, sinun tulee sallia selaimessasi ponnahdusikkunat",
        _4[Translation.RequestTranscriptButton] = "Lähetä keskustelu sähköpostiin",
        _4[Translation.Cancel] = "Peru",
        _4[Translation.Submit] = "Lähetä",
        _4[Translation.RequestTranscriptModalTitle] = "Pyydä kopio sähköpostiin",
        _4[Translation.FormError] = "Korjaa lomakkeella olevat virheet voidaksesi jatkaa",
        _4[Translation.EndChatModalMessage] = "Oletko varma, että haluat lopettaa chatin?",
        _4[Translation.ViewChat] = "Katso keskustelu",
        _4[Translation.Typing] = "Kirjoittaa",
        _4[Translation.ErrorInvalid] = "Virheellinen",
        _4[Translation.TranscriptRequested] = "Pyyntö lähetetty",
        _4[Translation.RequestTranscriptEmailLabel] = "Sähköpostiosoitteesi",
        _4[Translation.Yes] = "Kyllä",
        _4[Translation.BlockedAttachmentTitle] = "Liitteet estetty",
        _4[Translation.AgentIsTyping] = "Asiakaspalvelija kirjoittaa...",
        _4[Translation.EndChatButton] = "Lopeta chatti",
        _4[Translation.SkipSurvey] = "Ohita palaute",
        _4[Translation.ErrorRequired] = "Pakollinen",
        _4[Translation.NewChat] = "Uusi chatti",
        _4[Translation.GoToSurvey] = "Arvostele kokemuksesi",
        _4[Translation.ChatInputPlaceholder] = "Viestisi...",
        _4[Translation.Mute] = "Mykistä ilmoitus kuulostaa",
        _4[Translation.FinishedChatMoreOptions] = "Lisää vaihtoehtoja",
        _4[Translation.EmailTranscript] = "Lähetä keskustelu sähköpostiin",
        _4[Translation.CloseWindow] = "Close chat window",
        _4[Translation.Title] = "Tuki",
        _4[Translation.TooEarly] = "Virheellinen",
        _4[Translation.TooLate] = "Virheellinen",
        _4[Translation.TryingReconnect] = "Yritetään muodostaa uutta yhteyttä",
        _4[Translation.Back] = "Takaisin",
        _4[Translation.StartChat] = "Aloita chatti",
        _4[Translation.EndChatModalTitle] = "Lopeta chatti",
        _4[Translation.MinimiseWindow] = "Pienennä chatti-ikkuna",
        _4[Translation.PrintTranscriptButton] = "Tulosta selostus",
        _4[Translation.DownloadTranscriptButton] = "Lataa selostus",
        _4[Translation.EmptySelect] = "Mitään ei ole valittu",
        _4[Translation.NoItemsFound] = "Tuloksia ei löytynyt",
        _4[Translation.TypeToSearch] = "Hae...",
        _4),
    _a[Language.Czech] = (_5 = {},
        _5[Translation.ChatEnded] = "Chat skončil.",
        _5[Translation.ChangeLanguage] = "Změnit jazyk",
        _5[Translation.SurveyThanks] = "Děkujeme za vaši zpětnou vazbu.",
        _5[Translation.Unmute] = "Zazní zvuky upozornění",
        _5[Translation.OpenChat] = "otevřená podpora chatu",
        _5[Translation.Error] = "Chyba",
        _5[Translation.BlockedAttachmentMessage] = "Chcete-li zobrazit tuto přílohu, povolte ve svém prohlížeči vyskakovací okna.",
        _5[Translation.RequestTranscriptButton] = "Poslat přepis e-mailem",
        _5[Translation.Cancel] = "Zrušit",
        _5[Translation.Submit] = "Odeslat",
        _5[Translation.RequestTranscriptModalTitle] = "Vyžádat si přepis",
        _5[Translation.FormError] = "Chcete-li pokračovat, opravte chyby ve formuláři",
        _5[Translation.EndChatModalMessage] = "Opravdu chcete tento chat ukončit?",
        _5[Translation.ViewChat] = "Zobrazit přepis",
        _5[Translation.Typing] = "píšu",
        _5[Translation.ErrorInvalid] = "Neplatné",
        _5[Translation.TranscriptRequested] = "Přepis vyžádán",
        _5[Translation.RequestTranscriptEmailLabel] = "Vaše e-mailová adresa",
        _5[Translation.Yes] = "Ano",
        _5[Translation.BlockedAttachmentTitle] = "Přílohy blokovány",
        _5[Translation.AgentIsTyping] = "Zprostředkovatel píše...",
        _5[Translation.EndChatButton] = "Ukončit chat",
        _5[Translation.SkipSurvey] = "Přeskočit zpětnou vazbu",
        _5[Translation.ErrorRequired] = "Vyžadováno",
        _5[Translation.NewChat] = "Nový chat",
        _5[Translation.GoToSurvey] = "Ohodnoťte svou zkušenost",
        _5[Translation.ChatInputPlaceholder] = "Vaše zpráva...",
        _5[Translation.Mute] = "Ztlumit zvuky upozornění",
        _5[Translation.FinishedChatMoreOptions] = "Více možností",
        _5[Translation.EmailTranscript] = "Poslat přepis e-mailem",
        _5[Translation.CloseWindow] = "Close chat window",
        _5[Translation.Title] = "Pomoc",
        _5[Translation.TooEarly] = "Neplatné",
        _5[Translation.TooLate] = "Neplatné",
        _5[Translation.TryingReconnect] = "Pokouším se o nové spojení",
        _5[Translation.Back] = "Zpět",
        _5[Translation.StartChat] = "Zahájit chat",
        _5[Translation.EndChatModalTitle] = "Ukončit chat",
        _5[Translation.MinimiseWindow] = "Minimalizovat okno chatu",
        _5[Translation.PrintTranscriptButton] = "Vytisknout přepis",
        _5[Translation.DownloadTranscriptButton] = "Stáhnout přepis",
        _5[Translation.EmptySelect] = "Nic nebylo vybráno",
        _5[Translation.NoItemsFound] = "Nebyly nalezeny žádné výsledky",
        _5[Translation.TypeToSearch] = "Vyhledávání...",
        _5),
    _a[Language.Indonesian] = (_6 = {},
        _6[Translation.ChatEnded] = "Obrolan telah berakhir.",
        _6[Translation.ChangeLanguage] = "Ganti Bahasa",
        _6[Translation.SurveyThanks] = "Terima kasih atas umpan balik Anda.",
        _6[Translation.Unmute] = "Suarakan suara notifikasi",
        _6[Translation.OpenChat] = "buka dukungan obrolan",
        _6[Translation.Error] = "Eror",
        _6[Translation.BlockedAttachmentMessage] = "Harap aktifkan munculan di peramban Anda untuk melihat lampiran ini.",
        _6[Translation.RequestTranscriptButton] = "Kirim Transkripsi ke Surel",
        _6[Translation.Cancel] = "Batalkan",
        _6[Translation.Submit] = "Kirimkan",
        _6[Translation.RequestTranscriptModalTitle] = "Minta Transkripsi",
        _6[Translation.FormError] = "Harap perbaiki kesalahan pada formulir untuk melanjutkan",
        _6[Translation.EndChatModalMessage] = "Anda yakin ingin mengakhiri obrolan?",
        _6[Translation.ViewChat] = "Lihat Transkripsi",
        _6[Translation.Typing] = "mengetik",
        _6[Translation.ErrorInvalid] = "Tidak Benar",
        _6[Translation.TranscriptRequested] = "Transkripsi Telah Diminta",
        _6[Translation.RequestTranscriptEmailLabel] = "Alamat surel Anda",
        _6[Translation.Yes] = "Ya",
        _6[Translation.BlockedAttachmentTitle] = "Lampiran Diblokir",
        _6[Translation.AgentIsTyping] = "Agen sedang mengetik...",
        _6[Translation.EndChatButton] = "Akhiri Obrolan",
        _6[Translation.SkipSurvey] = "Lewatkan Umpan Balik",
        _6[Translation.ErrorRequired] = "Wajib",
        _6[Translation.NewChat] = "Obrolan Baru",
        _6[Translation.GoToSurvey] = "Beri Nilai Pengalaman Anda",
        _6[Translation.ChatInputPlaceholder] = "Pesan Anda...",
        _6[Translation.Mute] = "Bisukan pemberitahuan berbunyi",
        _6[Translation.FinishedChatMoreOptions] = "Opsi Lainnya",
        _6[Translation.EmailTranscript] = "Kirim Transkripsi ke Surel",
        _6[Translation.CloseWindow] = "Close chat window",
        _6[Translation.Title] = "Bantuan",
        _6[Translation.TooEarly] = "Tidak Benar",
        _6[Translation.TooLate] = "Tidak Benar",
        _6[Translation.TryingReconnect] = "Mencoba menyambung kembali",
        _6[Translation.Back] = "Kembali",
        _6[Translation.StartChat] = "Mulai Obrolan",
        _6[Translation.EndChatModalTitle] = "Akhiri Obrolan",
        _6[Translation.MinimiseWindow] = "Minimalkan Jendela Obrolan",
        _6[Translation.PrintTranscriptButton] = "Cetak Transkrip",
        _6[Translation.DownloadTranscriptButton] = "Unduh Transkrip",
        _6[Translation.EmptySelect] = "Tidak ada yang dipilih",
        _6[Translation.NoItemsFound] = "Hasil pencarian tidak ditemukan",
        _6[Translation.TypeToSearch] = "Cari...",
        _6),
    _a[Language.Hungarian] = (_7 = {},
        _7[Translation.ChatEnded] = "A chat véget ért.",
        _7[Translation.ChangeLanguage] = "Válts nyelvet",
        _7[Translation.SurveyThanks] = "Köszönjük a visszajelzést.",
        _7[Translation.Unmute] = "Unmute hangértesítései",
        _7[Translation.OpenChat] = "Nyílt Chat Support",
        _7[Translation.Error] = "Hiba",
        _7[Translation.BlockedAttachmentMessage] = "Kérjük, engedélyezze a pop-up a böngészőben, hogy megtekinthesse ezt a mellékletet.",
        _7[Translation.RequestTranscriptButton] = "Email Transcript",
        _7[Translation.Cancel] = "Megszünteti",
        _7[Translation.Submit] = "Beküldés",
        _7[Translation.RequestTranscriptModalTitle] = "Request Transcript",
        _7[Translation.FormError] = "Kérjük, javítsa ki a hibákat az űrlap a folytatáshoz.",
        _7[Translation.EndChatModalMessage] = "Biztosan be szeretné fejezni a chat?",
        _7[Translation.ViewChat] = "Részletek Transcript",
        _7[Translation.Typing] = "gépelés",
        _7[Translation.ErrorInvalid] = "Érvénytelen",
        _7[Translation.TranscriptRequested] = "transcript megkeresett",
        _7[Translation.RequestTranscriptEmailLabel] = "az email címed",
        _7[Translation.Yes] = "Igen",
        _7[Translation.BlockedAttachmentTitle] = "Mellékletek Blokkolt",
        _7[Translation.AgentIsTyping] = "A szer gépelés ...",
        _7[Translation.EndChatButton] = "Csevegés vége",
        _7[Translation.SkipSurvey] = "Skip Visszajelzés",
        _7[Translation.ErrorRequired] = "Kívánt",
        _7[Translation.NewChat] = "új Chat",
        _7[Translation.GoToSurvey] = "Értékeld Te élményed",
        _7[Translation.ChatInputPlaceholder] = "Az üzeneted...",
        _7[Translation.Mute] = "Mute hangértesítései",
        _7[Translation.FinishedChatMoreOptions] = "Több lehetőség",
        _7[Translation.EmailTranscript] = "E-mail átirat",
        _7[Translation.CloseWindow] = "Bezár chat ablak",
        _7[Translation.Title] = "Segítség",
        _7[Translation.TooEarly] = "Érvénytelen",
        _7[Translation.TooLate] = "Érvénytelen",
        _7[Translation.TryingReconnect] = "Újracsatlakozási",
        _7[Translation.Back] = "Vissza",
        _7[Translation.StartChat] = "Beszélgetés indítása",
        _7[Translation.EndChatModalTitle] = "Csevegés vége",
        _7[Translation.MinimiseWindow] = "Kis méret chat ablak",
        _7[Translation.PrintTranscriptButton] = "Nyomtassa átirat",
        _7[Translation.DownloadTranscriptButton] = "Letöltés átirat",
        _7[Translation.EmptySelect] = "Nincs semmi kiválasztva",
        _7[Translation.NoItemsFound] = "Nincs találat",
        _7[Translation.TypeToSearch] = "Keresés...",
        _7),
    _a[Language.Icelandic] = (_8 = {},
        _8[Translation.ChatEnded] = "Spjallinu er lokið.",
        _8[Translation.ChangeLanguage] = "Skipta um tungumál",
        _8[Translation.SurveyThanks] = "Takk fyrir álit þitt.",
        _8[Translation.Unmute] = "Kveikja á hljóði tilkynninga",
        _8[Translation.OpenChat] = "Opnaðu Chat Support",
        _8[Translation.Error] = "Villa",
        _8[Translation.BlockedAttachmentMessage] = "Vinsamlegast virkjaðu sprettiglugga í vafranum þínum til að skoða þetta viðhengi.",
        _8[Translation.RequestTranscriptButton] = "Tölvupóstafrit",
        _8[Translation.Cancel] = "Afbókun",
        _8[Translation.Submit] = "Sendu inn",
        _8[Translation.RequestTranscriptModalTitle] = "Óska eftir afriti",
        _8[Translation.FormError] = "Vinsamlegast lagfærðu villurnar á eyðublaðinu til að halda áfram.",
        _8[Translation.EndChatModalMessage] = "Ertu viss um að þú viljir hætta spjallinu?",
        _8[Translation.ViewChat] = "Skoða afrit",
        _8[Translation.Typing] = "vélritun",
        _8[Translation.ErrorInvalid] = "Ógilt",
        _8[Translation.TranscriptRequested] = "Uppskrift óskað",
        _8[Translation.RequestTranscriptEmailLabel] = "Netfangið þitt",
        _8[Translation.Yes] = "Já",
        _8[Translation.BlockedAttachmentTitle] = "Lokað fyrir viðhengi",
        _8[Translation.AgentIsTyping] = "Umboðsmaðurinn er að skrifa...",
        _8[Translation.EndChatButton] = "Ljúka spjalli",
        _8[Translation.SkipSurvey] = "Slepptu athugasemdum",
        _8[Translation.ErrorRequired] = "Áskilið",
        _8[Translation.NewChat] = "Nýtt spjall",
        _8[Translation.GoToSurvey] = "Gefðu reynslu þína einkunn",
        _8[Translation.ChatInputPlaceholder] = "Skilaboð þín...",
        _8[Translation.Mute] = "Þagga tilkynningarhljóð",
        _8[Translation.FinishedChatMoreOptions] = "Fleiri valkostir",
        _8[Translation.EmailTranscript] = "Tölvupóstafrit",
        _8[Translation.PrintTranscriptButton] = "Prenta afrit",
        _8[Translation.CloseWindow] = "Lokaðu spjallglugganum",
        _8[Translation.Title] = "Hjálp",
        _8[Translation.TooEarly] = "Of snemmt",
        _8[Translation.TooLate] = "Of seint",
        _8[Translation.TryingReconnect] = "Er að reyna að tengjast aftur",
        _8[Translation.Back] = "Til baka",
        _8[Translation.StartChat] = "Byrjaðu spjall",
        _8[Translation.EndChatModalTitle] = "Ljúka spjalli",
        _8[Translation.MinimiseWindow] = "Lágmarkaðu spjallglugga",
        _8[Translation.PrintTranscriptButton] = "Prenta afrit",
        _8[Translation.DownloadTranscriptButton] = "Sækja afrit",
        _8[Translation.EmptySelect] = "Ekkert valið",
        _8[Translation.NoItemsFound] = "Engar niðurstöður fundust",
        _8[Translation.TypeToSearch] = "Leita...",
        _8),
    _a);
export default locales;
//# sourceMappingURL=chat-window-locales.js.map